import { SharedService } from '../../services/sharedService/shared.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  FormArray,
} from '@angular/forms';
import { AppComponent } from '../../app.component';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DatePipe, DecimalPipe } from '@angular/common';
import Swal from 'sweetalert2';
import { ToastrService } from "ngx-toastr";

import { ExcelService } from '../../services/excel.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { Observable, startWith, Subject, Subscription, takeUntil } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { error } from 'jquery';
import { postServiceWorkerMessage } from 'src/serviceworker/message';
import { WorkerMessageType } from 'src/serviceworker/service/events/message';
import { WorkerUrlPrefetchResult, WorkerUrlPrefetchResultType } from 'src/serviceworker/service/prefetch';
import { LoaderService } from 'src/app/loader.service';
import { CommonPatternsService } from 'src/app/common-patterns.service';
import { LoggerService } from 'src/app/services/logger.service';
import { decompress } from 'compress-json';
import { SocketCorporateService } from 'src/app/services/socket-corporates.service';
import { loadCorporateData, loadCorporateDataSuccess } from 'src/app/state/actions/corporates.actions';
import { Store } from '@ngrx/store';
import { selectCorporateData, selectCorporateError, selectCorporateLoading } from 'src/app/state/selectors/corporates.selector';
import { selectLanguageData } from 'src/app/state/selectors';
import { loadLanguageData } from 'src/app/state/actions';
import { selectFormConfig2Data } from 'src/app/state/selectors/formConfig2.selectors';
import { loadFormConfig2Data } from 'src/app/state/actions/formConfig2.actions';

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}
declare var $: any;
@Component({
  selector: 'app-manage-clients-new',
  templateUrl: './manage-clients-new.component.html',
  styleUrls: ['./manage-clients-new.component.css'],
  providers: [ DecimalPipe, DatePipe],
  encapsulation: ViewEncapsulation.Emulated
})
export class ManageClientsNewComponent implements OnDestroy, OnInit {
  [x: string]: any;
  brokerList: Array<any> = [];
  clientList: Array<any> = [];
  myDateValue: Date;
  dateFormat = 'YYYY-MM-DD';

  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  disabledelement: string;
  dtOptions: DataTables.Settings = {};
  dtOptions2: DataTables.Settings = {};
  productobj: any
  persons: Array<any> = [];
  allBrokers: any;
  advisorBasedBrokers: any[] = [];
  globalCustomerId:any =''
  forms: any = [];
  plansskumain: any[] = [];
  plandetailsobjvalue: any;
  optionstitle: any[];
  optionmessage: any;
  showoptions: boolean = false;
  planssummarymain: any;
  planssummaryopt:any
  getEmployeePlans: Array<any> = [];
  dtInstance: DataTables.Api;
  dtTrigger: Subject<any> = new Subject<any>();
  dtTrigger1: Subject<any> = new Subject<any>();
  dtTrigger2: Subject<any> = new Subject<any>();
  dtTrigger3: Subject<any> = new Subject<any>();
  dtTrigger4: Subject<any> = new Subject<any>();
  dtTrigger5: Subject<any> = new Subject<any>();
  data1: { isActive: boolean }[] = [];
  public allplansArray: Array<any> = [];
  selectedRow: number = -1;
  customerslist: Array<any> = [];
  showCorporateEmployeeDetails: Array<any> = [];
  message: any;
  checkboxesForMail: any
  isCorporate: boolean
  languageData: any;
  showfilter: boolean = false;
  role: any;
  brokerprofiles: any;
  employeelist: Array<any> = [];
  finalEmployeeSelection: Array<any> = [];
  groupPlansList: any;
  fusbillid: any;
  paymentMethodId: any;
  showmemberData = false;
  corporateCompany: any;
  corporateCompany1: any;
  valuFormChaild: any = 1;
  clientDetails: any;
  loader: boolean;
  productsArray: Array<any> = [];
  notAllowedPlans: Array<any> = [];
  terminateMemberDetails: any = [];
  emplomentLastName:any;
  emplomentFirstName:any;
  terminationform: FormGroup = new FormGroup({
    reason: new FormControl(''),
    memberstatus: new FormControl(''),
    terminationDate: new FormControl(''),

  });
  terminationformDetails: FormGroup = new FormGroup({
    reason: new FormControl(''),
    memberstatus: new FormControl(''),
    terminationDate: new FormControl(''),
    proceedWithPHR: new FormControl(''),
    proceedWithEquitable: new FormControl(''),
    proceedWithGreenshield: new FormControl(''),
    proceedWithRefund: new FormControl(''),
    proceedWithSmartchoice: new FormControl(''),
    proceedWithSubscriptionExpiry: new FormControl(''),
    proceedWithCancelCustomer: new FormControl(''),
    refundAmount: new FormControl(),

  });
  minDate: any;
  maxDate: any;
  terminateReasonsWithKeys: any;
  terminateParentDetails: any;
  terminateAllDetails: any;
  bulkPlanEmployeeIds: any = [];
  servicDetails: any;
  terminateReasonsApplicable: any;
  staxbillDetails: any;
  proceedWithSubscriptionExpiry: any;
  proceedWithEquitable: any;
  proceedWithGreenshield: any;
  proceedWithRefund: any;
  proceedWithSmartchoice: any;
  proceedWithCancelCustomer: any;
  terminationsProvisioning: any;
  employeeFirstName: any;
  employeeLastName: any;
  corporateName: any;
  refundAmount: any;
  memberid: any;
  version: string;
  allClientList: any[];
  filterStatus: any[];
  employeelistfilter: any;
  corporateCustomerAccount: any;

  corporatename: any;
  employeelist2: any[];
  abc: string;
  terminationDateValue: any;
  @ViewChild('dp') dpicker: ElementRef;
  corporateBulkPlan: any;
  isSubscribed: any;
  public lang: any = {};
  brokervalue: any = 1161
  selectedLanguage: string;
  filterValue: String = '';
  currentPage: number = 1;
  itemsPerPage: number = 10;
  private socketSubscription: Subscription;
  restLoader: boolean = true;
  loading$: Observable<boolean>;
  error$: Observable<string | null>;
  corporateData$: Observable<any>;
  languageData$: Observable<any>;
  formConfig2Data: any = {};
  formConfig2Data$: Observable<any>;
  private destroy$ = new Subject<void>();
  sortColumn: string = '';
  sortOrder: 'ASC' | 'DESC' = 'ASC';
  empprofilesid: any = '';
  groupPlanlist: any = '';
  showCorporateEmployees: boolean = false;
  customerName: any;
  employeeForm: FormGroup;
  invitationId: any;
  sendInviteClicked: boolean=false;

  constructor(private logger: LoggerService,
    private renderer: Renderer2,
    private toastrService: ToastrService,
    private SharedService: SharedService,
    private CommonService: CommonPatternsService,
    private socketCorporateService: SocketCorporateService,
    private _LoaderService: LoaderService,
    private formBuilder: FormBuilder,
    private formBuilderDetails: FormBuilder,
    private http: HttpClient,
    public router: Router,
    public elementRef: ElementRef,
    private datePipe: DatePipe,
    private _decimalPipe: DecimalPipe,
    private excelService: ExcelService,
    private store: Store<{ corporateData: [], languageData: [], formConfig2Data: [] }>
  ) {
    this.corporateData$ = store.select(selectCorporateData);
    this.loading$ = store.select(selectCorporateLoading);
    this.error$ = store.select(selectCorporateError);
    this.languageData$ = store.select(selectLanguageData);
    this.formConfig2Data$ = store.select(selectFormConfig2Data);
    this.employeeForm = this.formBuilder.group({
      employees: this.formBuilder.array([]) // Initialize as an empty array
    });
  }

  ngOnInit() {
    setTimeout(()=>{
      sessionStorage.setItem('pageName', 'Corporate Customers List');
    },100)
    // this.getFormConfig()
    this.brokervalue = 1161
    this.getLanguageTokens()
    this.isSubscribed = false
    // this._LoaderService.ShowLoader()
    this.version = environment.version;
    this.role = sessionStorage.getItem('role');
    // this.setMinDateBasedOnRole()
    // this.ShowDetails()

    this.terminationform = this.formBuilder.group({
      reason: [''],
      memberstatus: [''],
      terminationDate: ['', [Validators.required],],
    });
    this.dtOptions = {
      pagingType: 'simple_numbers',
      order: [],
      language: {
        searchPlaceholder: 'Search here...'
      },
      destroy: true
      // columnDefs: [
      //   {
      //     targets: '_all', // Index of the 'id' column
      //     orderable: false, // Disable sorting for this column
      //   },
      // ],
    };
    this.dtOptions2 = {
      pagingType: 'simple_numbers',
      order: [],
      language: {
        searchPlaceholder: 'Search here...'
      },
      destroy: true,
      columnDefs: [
        {
          targets: [5], // Index of the 'id' column
          type: 'date',
        },
      ],
    };

    this.getclientList();

    let role = sessionStorage.getItem('role')
    if (role == 'ADMINISTRATOR') {
      this.initCorporateSocket()
    }
    // this.getServiceWorkerDetails()
  }

  // ngOnInit(): void {
  //   this.getLanguageTokens()
  //   this.store.dispatch(loadCorporateData());
  //   this.dtOptions = {
  //     pagingType: 'simple_numbers',
  //     order: [],
  //     language: {
  //       searchPlaceholder: 'Search here...'
  //     },
  //     destroy: true,
  //   };
  //   this.corporateData$ = this.store.select(state => state.corporateData).pipe(
  //     // startWith([]),
  //     // takeUntil(this.destroy$)
  //   );
  //   this.corporateData$.subscribe(data => {
  //     if (data) {
  //       console.log(data)
  //     if (data?.corporateData == undefined || Object.keys(data.corporateData).length <= 0) {
  //       console.log('No data to process', new Date().toISOString());
  //       return;
  //     }
  //     if(this.clientList.length>0){
  //       return;
  //     }
  //     this.sortColumn = 'name';
  //     this.sortOrder = 'ASC';
  //     this.loader = false;

  //     const role = sessionStorage.getItem('role');
  //     if (role == 'ADMINISTRATOR') {
  //       this.clientList = decompress(data.corporateData)
  //     } else {
  //       this.clientList = data.corporateData.map(res => {
  //         return {
  //           ...res,
  //           formsLength: res.forms?.length || 0
  //         }
  //       })
  //     }
  //     this.filterStatus = [];
  //     this.clientList.map((member) => {
  //       if (!this.filterStatus.includes(member.status))
  //         this.filterStatus.push(member.status);
  //       if(!member.published||member.published==undefined||member.published==null){
  //         return { ...member, published:false }
  //       }else{
  //         return { ...member }
  //       }
  //     });
  //     console.log(this.clientList)
  //     this.allClientList = this.clientList;
  //     this.clientList.sort((a, b) => {
  //       const order = { true: 1, false: 2, cancelled: 3 };
  //       if (order[a.status] !== order[b.status]) {
  //         return order[a.status] - order[b.status];
  //       }
  //       return a.name.trim().localeCompare(b.name.trim());
  //     });
  //     setTimeout(() => {
  //       this.restLoader = false;
  //       // this.dtTrigger.next(null);
  //     }, 0);
  //     } else {
  //       console.error('Observable returned undefined');
  //     }
  //   })
  //   setTimeout(()=>{
  //     this.isSubscribed = false
  //     this.version = environment.version;
  //     this.role = sessionStorage.getItem('role');
  //     this.terminationform = this.formBuilder.group({
  //       reason: [''],
  //       memberstatus: [''],
  //       terminationDate: ['', [Validators.required]],
  //     });
  //     if (this.role == 'ADMINISTRATOR') {
  //       this.initCorporateSocket();
  //     }
  //   },100)
  // }

  initCorporateSocket() {
    console.log('CorporateGateway', 'Initialized');
    this.socketSubscription = this.socketCorporateService
      .listen('corporateUpdated')
      .subscribe((data) => {
        if (data && data.message) {
          this.toastrService.warning(data.message, '', { timeOut: 3000 });
        }
      });
  }

  public getLanguageTokens() {
    // let body = {
    //   "project": "Admin Portal",
    //   "url": "manageCorporates"
    // }
    // this.http
    //   .post('https://languageengineapi.aitestpro.com/string/project-url-strings', body, {
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .subscribe(
    //     (response: any) => {
    //       console.log(response)
    //       this.lang = {};
    //       this.languageData = response.strings
    //       this.selectedLanguage = sessionStorage.getItem("language")
    //       for (let token of response.strings) {
    //         this.lang[token.key] = token[this.selectedLanguage];
    //       }
    //       console.log(this.lang)
    //     })

    // this.store.dispatch(loadLanguageData());

    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    this.languageData$.subscribe(data => {
      if (data) { 
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        // if(Object.keys(this.lang).length>0){
        //   return;
        // }
        setTimeout(() => {
          this.lang = {};
          this.languageData = data?.languageData
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          // console.log('this.lang',this.lang)
        }, 0)
      }
    })

  }

  // getServiceWorkerDetails() {
  //   var getClients = '/api/ap/admin/corporate/details/false';


  //   let prefetchurls = []

  //   let Data = [{
  //     url: environment.apiUrl + getClients,
  //     // fetch options
  //     options: {

  //       mode: 'cors',
  //       headers: {

  //         Authorization: 'Bearer ' + sessionStorage.getItem('accessToken'),
  //         'Content-Type': 'application/json',
  //       }
  //     }
  //   }]
  //   prefetchurls = Data

  //   postServiceWorkerMessage(WorkerMessageType.Prefetch, prefetchurls).then((results: WorkerUrlPrefetchResult) => {
  //     $("#DataTables_Table_0").dataTable().fnDestroy();

  //     // this._LoaderService.HideLoader()


  //     setTimeout(() => {
  //       this.clientList = results[0].response.data
  //       // this.clientList = (response as any).data;
  //       this.filterStatus = [];
  //       this.clientList.map((member) => {
  //         if (!this.filterStatus.includes(member.status))
  //           this.filterStatus.push(member.status);
  //       });
  //       this.allClientList = this.clientList;
  //       this.clientList.sort((a, b) => {

  //         const order = { true: 1, false: 2, cancelled: 3 };

  //         if (order[a.status] !== order[b.status]) {
  //           return order[a.status] - order[b.status];
  //         }


  //         return a.name.trim().localeCompare(b.name.trim());
  //       });
  //       this.dtTrigger.next(null);
  //       setTimeout(() => {
  //         this.showfilter = true;
  //       }, 1000);
  //     }, 1000);



  //   })
  // }
  selectRow(i) {
    this.selectedRow = i;
    this.logger.log(this.selectedRow, "row")
  }
  public note: string = ""
  public enroll: any
  setMinDateBasedOnRoleAndStatus(client: any) {
    const today = new Date();
    this.maxDate = new Date(2027, 9, 1);
    if (this.role === 'BROKER') {
      this.minDate = today;
      this.note = this.lang.Required_backdated_selection_contact_Administrator
      return
    } else if (this.role === 'ADMINISTRATOR') {
      const threeMonthsFromNow = new Date(today.setMonth(today.getMonth() - 3));
      this.minDate = new Date(threeMonthsFromNow.getFullYear(), threeMonthsFromNow.getMonth(), 1);
      if (client.status === "Active" && client.planActivationDate) {
        this.enroll = new Date(client.planActivationDate)
        if (this.minDate <= this.enroll && this.enroll < new Date()) {
          this.minDate = this.enroll
          this.note = this.lang.enrollment_date_is_the_earliest_selection
          this.logger.log("mindate", this.minDate)
          return
        }
        if (this.minDate < this.enroll && this.enroll >= new Date()) {
          this.minDate = new Date()
          this.note = this.lang.Today_is_the_earliest_selection
          this.logger.log("mindate", this.minDate)

          return
        }
        this.note = this.lang.Can_select_from_3_months_from_the_past
      }
      if (client.status === "Draft") {
        this.minDate = null
        this.note = ""
        return
        // this.logger.log("mindate draft", this.minDate)
      }
      this.logger.log("mindate", this.minDate)
    }

  }

  terminationformDetailsValidations() {
    this.terminationformDetails = this.formBuilderDetails.group({
      reason: [''],
      memberstatus: [''],
      terminationDate: [''],
      proceedWithEquitable: [''],
      proceedWithGreenshield: [''],
      proceedWithRefund: [''],
      proceedWithSmartchoice: [''],
      proceedWithSubscriptionExpiry: [''],
      proceedWithCancelCustomer: [''],
      refundAmount: [''],
      proceedWithPHR: [''],
    });
  }

  isDisabled() {
    const checkVal = this.terminateParentDetails?.staxbillDetails ? this.terminateParentDetails?.staxbillDetails?.refundApplicable == false ? true : false : true
    return checkVal;
  }

  changeStatus(e: any) {
    this.showfilter = false;
    $("#DataTables_Table_0").dataTable().fnDestroy();
    this.clientList = [];

    let val = e.target.value.toLowerCase();//member.status.toLowerCase()==val
    if (val == 'all') {
      this.clientList = this.allClientList;
    } else {
      this.clientList = this.allClientList.filter((member) => {
        if (member.status?.toString().toLowerCase() == val) {
          return member;
        }
      });
    }
    this.dtTrigger.next(null);
    this.logger.log(this.clientList);
    // this.dtTrigger.next(null);
    // this.dtTrigger.unsubscribe();

    setTimeout(() => {
      this.showfilter = true;

    }, 500);

  }

  changeStatusmembers(e: any) {
    $("#DataTables_Table_1").dataTable().fnDestroy();
    this.employeelistfilter = [];

    let val = e.target.value.toLowerCase();//member.status.toLowerCase()==val

    if (val == 'all') {
      this.employeelistfilter = [...this.employeelist];
    } else {
      this.employeelistfilter = this.employeelist.filter((member) => {
        if (member.status?.toString().toLowerCase() == val) {
          return member;
        }
      });
      this.logger.log({ empfilter: this.employeelist })
    }
    this.dtTrigger1.next(null);
    this.logger.log(this.employeelistfilter);
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger1.next(null);
      this.dtTrigger3.next(null);
      this.dtTrigger5.next(null);
    });
  }


  terminatemember(client: any, index: number) {
    console.log(client)
    this.terminationform.reset();
    this.setMinDateBasedOnRoleAndStatus(client)
    this.corporateName = client.name;
    this.memberid = client.uId;
    this.emplomentFirstName = client.firstName;//client.name;
    this.emplomentLastName = client.lastName;//client.name;
    $("#terminateConfirmDateModal").modal('show');
    $("#showmemberlist").modal('hide')
    $("#DataTables_Table_1").dataTable().fnDestroy();


  }

  onNavigate(event: { viewDate: Date }) {
    const year = event.viewDate.getFullYear();
    const month = event.viewDate.getMonth();

    if (year === 2025 && month === 0) {
      alert("1")
      // Prevent navigating to January 2025
      // this.bsConfig = {
      //   ...this.bsConfig,
      //   maxDate: new Date(2024, 11, 31),
      // };
    }
  }

  terminateCorporate(client: any, index: number) {
    this.getFormConfig()
    console.log(client)
    console.log(this.allBrokers)
    console.log(client.parentName)
this.brokerprofiles =client

    this.terminationform.reset();
    this.setMinDateBasedOnRoleAndStatus(client)
    this.corporateName = client.name;
    this.memberid = client.id;
    if (client.customersCount != 0) {

      Swal.fire({
        title: 'Info',
        text: 'Do you want to convert employees to GIG profiles?',
        showCancelButton: true,
        confirmButtonColor: '#10104d',
        cancelButtonColor: '#10104d',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        html: `
<div>Do you want to convert employees to GIG profiles?</div>
    <button id="custom-close" class="swal2-close" style="position: absolute; top: 10px; right: 10px; background: transparent; border: none; font-size: 18px; cursor: pointer;">
      <i class="fa fa-times"></i>
    </button>
  `,
        didOpen: () => {
          // Add custom close button behavior
          const closeButton = document.getElementById('custom-close');
          if (closeButton) {
            closeButton.addEventListener('click', () => {
              Swal.close();
            });
          }
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.showCorporateEmployees = true
          $("#terminateConfirmDateModalCorporate").modal('show');
          $("#showmemberlist").modal('hide');
          $("#DataTables_Table_5").dataTable().fnDestroy();
          // this.getFormConfig();
        }
        else {

          this.showCorporateEmployees = false
          $("#terminateConfirmDateModalCorporate").modal('show');
          $("#showmemberlist").modal('hide');
          $("#DataTables_Table_5").dataTable().fnDestroy();
        }
      })
    }
    else {
      this.showCorporateEmployees = false
      $("#terminateConfirmDateModalCorporate").modal('show');
      $("#showmemberlist").modal('hide');
      $("#DataTables_Table_5").dataTable().fnDestroy();
    }

  }


  getFormConfig() {
    // let formLink = environment.app.formLink
    // var accessToken = sessionStorage.getItem('accessToken');
    // var endPoint = '/api/ap/customer/formConfig_2';

    // let lang = 'en';
    // this.http
    //   .get(environment.apiUrl + endPoint, {
    //     headers: {
    //       Authorization: 'Bearer ' + accessToken,
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .subscribe(
    //     (result: any) => {
    //       // this.isLoaded =true
    //       if (result.status == '200') {
    //         this.allBrokers = result.data.allBrokers.sort(
    //           (a: any, b: any) => (a.name > b.name ? 1 : -1)
    //         );
    //         console.log(this.allBrokers)
    //         this.logger.log('result: ' + JSON.stringify(result))
    //       }
    //       else {
    //         Swal.fire({
    //           title: '<strong>HTML <u>example</u></strong>',
    //           // icon: 'warning',
    //           html: `<div class="custom-content">${result.message ? result.message : result.error
    //             }</div>`,
    //           showCloseButton: true,
    //           showCancelButton: false,
    //           focusConfirm: false,
    //           confirmButtonText: 'OK',
    //           confirmButtonAriaLabel: 'Thumbs up, great!',
    //           cancelButtonText: '<i class="fa fa-thumbs-down"></i>',
    //           cancelButtonAriaLabel: 'Thumbs down',
    //         });
    //       }
    //     },
    //     (error) => {
    //       if (
    //         error.status == 400 ||
    //         error.status == 401 ||
    //         error.status == 402 ||
    //         error.status == 403
    //       ) {
    //         Swal.fire({
    //           title: this.lang.Error ?? 'Error',
    //           text: error.error.error.message,
    //           showDenyButton: false,
    //           showCancelButton: false,
    //           confirmButtonText: this.lang.Proceed,
    //         }).then((result) => {
    //           if (result.isConfirmed) {
    //             sessionStorage.clear();
    //             this.router.navigate(['/login']);
    //           }
    //           else {
    //             sessionStorage.clear();
    //             this.router.navigate(['/login']);
    //           }
    //         });
    //       } else {
    //         Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
    //       }
    //     }
    //   );


      this.store.dispatch(loadFormConfig2Data());
      this.formConfig2Data$ = this.store.select(state => state.formConfig2Data).pipe(
        // startWith([]),
        // takeUntil(this.destroy$)
      );
      this.formConfig2Data$.subscribe(data => {
        if (data) {
          console.log(data)
        if (data?.formConfig2Data == undefined || Object.keys(data.formConfig2Data).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        if(Object.keys(this.formConfig2Data).length>0){
          return;
        }
        this.formConfig2Data = { ...data.formConfig2Data }
        this.allBrokers = [...this.formConfig2Data.allBrokers].sort(
          (a: any, b: any) => (a.name > b.name ? 1 : -1)
          );


        // console.log(this.allBrokers)
        } else {
          console.error('Observable returned undefined');
        }
      })
  }
  getForms(id: any) {
    // console.log(this.allBrokers)

    return this.allBrokers.filter(form => form.id == id);
    //     this.forms = this.allBrokers.filter((broker) => {
    //       if (broker.id == id) {
    //         console.log(broker)
    //         // this.FormbrokerType = broker.brokerType
    //         return broker;
    //       }
    //     });

    // console.log(this.forms)
    //     this.forms[0].signupForms.sort((a, b) => {
    //       let fa = a.formType.toLowerCase(),
    //         fb = b.formType.toLowerCase();

    //       if (fa < fb) {
    //         return -1;
    //       }
    //       if (fa > fb) {
    //         return 1;
    //       }
    //       return 0;
    //     });

  }

  onBrokerChange(selectedBrokerId: any, terminateDetails: any): void {


    // console.log(terminateDetails)
    console.log(selectedBrokerId)
    // terminateDetails.brokerId = selectedBrokerId;

    // // Optional: Load forms for the selected broker if needed
    // this.getForms(selectedBrokerId);
    const filteredForms = this.getForms(selectedBrokerId);
    console.log(filteredForms)
    // Update the forms list for this specific row
    terminateDetails.forms = filteredForms[0].signupForms;

    console.log(terminateDetails.forms)
    console.log(terminateDetails)
    if (terminateDetails.forms.length === 1) {
      terminateDetails.formId = terminateDetails.forms[0].id;
    }
    // const isValidFormId = terminateDetails.forms.some((form) => form.id === terminateDetails.forms.formId);

    // // If formId is invalid or not set, default to the first form's id
    // if (!isValidFormId && terminateDetails.forms.length > 0) {
    //   terminateDetails.forms.formId = terminateDetails.forms[0].id;
    // }

    // Clear the previously selected form (if any)
    // terminateDetails.formId = null;
  }

  onFormChange(selectedFormId: string, terminateDetails: any): void {
    // terminateDetails.formId = selectedFormId;

    // Optional: Perform an action based on the selected form
    console.log(`Form ${selectedFormId} selected for customer ${terminateDetails.customerName}`);
  }
  toggleAllPlans(event: any) {
    if (event.target.checked) {

      this.changePackageCheckedValues(true)

    }
    else {
      this.changePackageCheckedValues(false)

    }

  }
  changePackageCheckedValues(bool: boolean) {
    this.terminateMemberDetails['packageCheckbox'] = bool;
    Object.keys(this.terminateMemberDetails).forEach((p, id) => {
      if (typeof this.terminateMemberDetails[p] === 'object') {
        this.terminateMemberDetails[p]['planCheckbox'] = bool;
      }
    })


    console.log({ plansArray: this.terminateMemberDetails })

  }
  planCheckbox(customerId: any, event: any) {
    let disabled = true

    console.log(customerId)
    console.log(this.terminateMemberDetails)
    if (event.target.checked) {

      const customer = this.terminateMemberDetails.find(
        (detail) => detail.customerId === customerId
      );
      customer.planCheckbox = true;


      // this.terminateMemberDetails[customerId].planCheckbox = true;
      this.changePlanCheckedValues(customerId)

    }
    else {
      const customer = this.terminateMemberDetails.find(
        (detail) => detail.customerId === customerId
      );
      customer.planCheckbox = false;
      this.changePlanCheckedValues(customerId)
    }
    this.checkForAllPlansChecked(customerId)

  }
  changePlanCheckedValues(customerId: any) {
    const customer = this.terminateMemberDetails.find(
      (detail) => detail.customerId === customerId
    );
    customer.packageCheckbox = false;
    customer.checked = false;

    this.checkForAllPlansChecked(customerId)

    console.log(this.terminateMemberDetails)

  }
  checkForAllPlansChecked(customerId: any) {

    // let planFlag = Object.keys(this.terminateMemberDetails[customerId]).some((p) => {
    //   return (typeof this.terminateMemberDetails[customerId][p] === 'object' && this.terminateMemberDetails[customerId][p]['planCheckbox'] === false)
    // });
    // this.terminateMemberDetails[customerId].checked = !planFlag;


    // let flag = Object.keys(this.terminateMemberDetails[customerId]).some((p) => {
    //   return (typeof this.terminateMemberDetails[customerId][p] === 'object' && this.terminateMemberDetails[customerId][p]['planCheckbox'] === false)
    // });


    // this.terminateMemberDetails[customerId].packageCheckbox = !flag;


    console.log({ plansAyyay: this.terminateMemberDetails })
  }
  viewPlansForEmployee(employeeDetails) {
    console.log(employeeDetails)
    this.customerName = employeeDetails.customerName
    this.showCorporateEmployeeDetails = employeeDetails.customerPlans
    $('#viewCorporateEmployeeplans').modal('show');
  }
  isAnyPlanCheckboxSelected(): boolean {
    return this.terminateMemberDetails?.some(item => item.planCheckbox) || false;
  }
  adminApprove(client) {

    Swal.fire({
      title: 'Info',
      text: 'Are you sure you want to approve ? Please be advised that the payment and ROE will not be displayed in the dashboard until corporate signing is done.',
      showCancelButton: true,
      confirmButtonColor: '#10104d',
      cancelButtonColor: '#10104d',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        var accessToken = sessionStorage.getItem('accessToken');
        var corporateId = sessionStorage.getItem('corporateId');
        var adminApprove = `/api/ap/admin/corporate/${client.id}/adminApproveOverride/11-07-2024`

        this.http.get(environment.apiUrl + adminApprove, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
          .subscribe(async (responce: any) => {
            if (responce.status == '200') {
              Swal.fire({ title: "info", text: responce.message });
              this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => { })
              // this.http.post(environment.apiUrl+'/api/ap/v2/global/set-adminCorporates',{wait:true}).subscribe((newResponse) => {})
              this.clientList = this.clientList.map(clien =>
                clien.id == client.id ? { ...clien, adminApproved: true } : clien
              );
              this.store.dispatch(loadCorporateDataSuccess({ corporateData: this.clientList }))
              this.store.dispatch(loadCorporateData())
              this.router.navigate(['/manageCorporates/' + client.id + '/view']);
            } else {
              Swal.fire({ title: "info", text: responce.message });
            }

          }, (error) => {
            Swal.fire({ title: "Error", text: error.message || error.data.message });
          })
      }
    });




  }
  submitterminationEnd() {

    //here we have to update every member details


    this.terminateAllDetails.forEach(cust => {
      cust.proceedWithGreenshield = cust.proceedWithGreenshield ? this.terminationformDetails.get('proceedWithGreenshield').value : cust.proceedWithGreenshield;
      cust.proceedWithRefund = cust.proceedWithRefund ? this.terminationformDetails.get('proceedWithRefund').value : cust.proceedWithRefund;
      cust.proceedWithSmartchoice = cust.proceedWithSmartchoice ? this.terminationformDetails.get('proceedWithSmartchoice').value : cust.proceedWithSmartchoice;
      cust.proceedWithSubscriptionExpiry = cust.proceedWithSubscriptionExpiry ? this.terminationformDetails.get('proceedWithSubscriptionExpiry').value : cust.proceedWithSubscriptionExpiry;
      cust.proceedWithCancelCustomer = cust.proceedWithCancelCustomer ? this.terminationformDetails.get('proceedWithCancelCustomer').value : cust.proceedWithCancelCustomer
      cust.proceedWithEquitable = cust.proceedWithEquitable ? this.terminationformDetails.get('proceedWithEquitable').value : cust.proceedWithEquitable
      cust.refundAmount = cust.refundAmount ? this.terminationformDetails.get('refundAmount').value : cust.refundAmount
    })


    let data = {
      'data': this.terminateAllDetails,
      'bulkPlanEmployeeIds': this.bulkPlanEmployeeIds,
      'reason': this.terminationformDetails.get('reason').value ?? " ",
    };
    this.logger.log(this.terminationform.value)
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var terminate = '/api/ap/admin/corporate/' + this.memberid + '/terminate';
    var headers = {
      Authorization: 'Bearer ' + accessToken,
      'Content-Type': 'application/json',
    };

    this.http.post(environment.apiUrl + terminate, data, { headers: headers })
      .subscribe(async (responce: any) => {
        if (responce.status == '200') {

          var getClients = 'api/ap/admin/corporate/details/false';

          // await postServiceWorkerMessage(WorkerMessageType.Delete, [
          //   environment.apiUrl + getClients
          // ]);

          Swal.fire({ title: "Info", html: responce.message }).then((res) => {
            this.clientList = this.clientList.map(member =>
              member.id == this.memberid ? { ...member, status: 'Cancelled' } : member
            );
            // this.members=[]
            this.store.dispatch(loadCorporateDataSuccess({ corporateData: this.clientList }))
            if (res.isConfirmed) {
              this.store.dispatch(loadCorporateDataSuccess({ corporateData: [] }));
              // this.store.dispatch(loadCorporateData())

              this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => { })


              this.getclientList();
              // this.getServiceWorkerDetails()
              $("#DataTables_Table_0").dataTable().fnDestroy();
              // this.dtTrigger.next(null);
            }
          });
          $('#showTerminateMemberDetails').modal('hide');

        } else {
          Swal.fire({ title: "info", text: responce.data.message });
        }

      }, (error) => {
        Swal.fire({ title: "Error", text: error.message || error.data.message });
      })
  }
  submitterminationEndCorporate() {


    //here we have to update every member details
    if (!this.showCorporateEmployees) {

      this.terminateAllDetails.forEach(cust => {
        cust.proceedWithGreenshield = cust.proceedWithGreenshield ? this.terminationformDetails.get('proceedWithGreenshield').value : cust.proceedWithGreenshield;
        cust.proceedWithRefund = cust.proceedWithRefund ? this.terminationformDetails.get('proceedWithRefund').value : cust.proceedWithRefund;
        cust.proceedWithSmartchoice = cust.proceedWithSmartchoice ? this.terminationformDetails.get('proceedWithSmartchoice').value : cust.proceedWithSmartchoice;
        cust.proceedWithSubscriptionExpiry = cust.proceedWithSubscriptionExpiry ? this.terminationformDetails.get('proceedWithSubscriptionExpiry').value : cust.proceedWithSubscriptionExpiry;
        cust.proceedWithCancelCustomer = cust.proceedWithCancelCustomer ? this.terminationformDetails.get('proceedWithCancelCustomer').value : cust.proceedWithCancelCustomer
        cust.proceedWithEquitable = cust.proceedWithEquitable ? this.terminationformDetails.get('proceedWithEquitable').value : cust.proceedWithEquitable
        cust.refundAmount = cust.refundAmount ? this.terminationformDetails.get('refundAmount').value : cust.refundAmount
      })


      let data = {
        'data': this.terminateAllDetails,
        'bulkPlanEmployeeIds': this.bulkPlanEmployeeIds,
        'reason': this.terminationformDetails.get('reason').value ?? " ",
      };
      this.logger.log(this.terminationform.value)
      var corporateId = sessionStorage.getItem('corporateId');
      var accessToken = sessionStorage.getItem('accessToken');
      var terminate = '/api/ap/admin/corporate/' + this.memberid + '/terminate';
      var headers = {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      };

      this.http.post(environment.apiUrl + terminate, data, { headers: headers })
        .subscribe(async (responce: any) => {
          if (responce.status == '200') {

            var getClients = 'api/ap/admin/corporate/details/false';

            // await postServiceWorkerMessage(WorkerMessageType.Delete, [
            //   environment.apiUrl + getClients
            // ]);

            Swal.fire({ title: "Info", html: responce.message }).then((res) => {
              if (res.isConfirmed) {

                // this.store.dispatch(loadCorporateData())

                this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => { })

                this.clientList = this.clientList.map(member =>
                  member.id == this.memberid ? { ...member, status: 'Cancelled' } : member
                );
                // this.members=[]
                this.store.dispatch(loadCorporateDataSuccess({ corporateData: this.clientList }))

                this.getclientList();
                // this.getServiceWorkerDetails()
                // $("#DataTables_Table_0").dataTable().fnDestroy();
                this.dtTrigger.next(null);
              }
            });
            $('#showTerminateMemberDetailsCorpoarte').modal('hide');

          } else {
            Swal.fire({ title: "info", text: responce.data.message });
          }

        }, (error) => {
          Swal.fire({ title: "Error", text: error.message || error.data.message });
        })
    }
    else {

      this.terminateAllDetails.forEach(cust => {
        cust.proceedWithGreenshield = cust.proceedWithGreenshield ? this.terminationformDetails.get('proceedWithGreenshield').value : cust.proceedWithGreenshield;
        cust.proceedWithRefund = cust.proceedWithRefund ? this.terminationformDetails.get('proceedWithRefund').value : cust.proceedWithRefund;
        cust.proceedWithSmartchoice = cust.proceedWithSmartchoice ? this.terminationformDetails.get('proceedWithSmartchoice').value : cust.proceedWithSmartchoice;
        cust.proceedWithSubscriptionExpiry = cust.proceedWithSubscriptionExpiry ? this.terminationformDetails.get('proceedWithSubscriptionExpiry').value : cust.proceedWithSubscriptionExpiry;
        cust.proceedWithCancelCustomer = cust.proceedWithCancelCustomer ? this.terminationformDetails.get('proceedWithCancelCustomer').value : cust.proceedWithCancelCustomer
        cust.proceedWithEquitable = cust.proceedWithEquitable ? this.terminationformDetails.get('proceedWithEquitable').value : cust.proceedWithEquitable
        cust.refundAmount = cust.refundAmount ? this.terminationformDetails.get('refundAmount').value : cust.refundAmount
      })


      let selectEmployees = []
      console.log(this.terminateMemberDetails)

      this.terminateMemberDetails.forEach(element => {
        if (element?.planCheckbox && element?.planCheckbox == true) {
          selectEmployees.push(element.customerId)
        }

      });
      let data = {
        'data': this.terminateAllDetails,
        selectedEmployeeIds: selectEmployees
      };
      this.logger.log(this.terminationform.value)
      var corporateId = sessionStorage.getItem('corporateId');
      var accessToken = sessionStorage.getItem('accessToken');
      var terminate = '/api/ap/admin/corporate/' + this.memberid + '/terminate';
      var headers = {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      };
      console.log(data)
      let getPlans = '/api/ap/admin/corporate/' + this.memberid + '/terminateConfigurationPlans'
      this.http.post(environment.apiUrl + getPlans, data, { headers: headers })
        .subscribe(async (response: any) => {
          // if (responce.status == '200') {

          sessionStorage.setItem('plansummaryLife', '[]');
          sessionStorage.setItem('planssummarymainLife', '[]');
          sessionStorage.setItem('plansummary', '[]');

          sessionStorage.setItem('selectedPlans', '{}');
          sessionStorage.setItem('selectedPlansLife', '{}');
          sessionStorage.setItem('plansummarymain', '[]');
          sessionStorage.setItem('plansummaryopt', '[]');
          sessionStorage.setItem('studentsPlansArray', '[]');
          sessionStorage.setItem('allproducts', '[]');
          sessionStorage.setItem('totalAmount', '');
          sessionStorage.setItem('totalAmountUI', '');
          sessionStorage.setItem('planDetailsArray', '[]');
          this.getEmployeePlans = response.data

          $('#showTerminateMemberDetailsCorpoarte').modal('show');
          $('#showTerminateMemberDetailsCorpoarteList').modal('show');
          // this.store.dispatch(loadCorporateData())

          this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => { })

          this.clientList = this.clientList.map(member =>
            member.id == this.memberid ? { ...member, status: 'Cancelled' } : member
          );
          // this.members=[]
          this.store.dispatch(loadCorporateDataSuccess({ corporateData: this.clientList }))

          this.getclientList();
          // this.getServiceWorkerDetails()
          // $("#DataTables_Table_0").dataTable().fnDestroy();
          this.dtTrigger.next(null);



          // } else {
          //   Swal.fire({ title: "info", text: responce.data.message });
          // }

        }, (error) => {
          Swal.fire({ title: "Error", text: error.message || error.data.message });
        })



      console.log(this.terminateMemberDetails)

      this.finalEmployeeSelection = this.terminateMemberDetails.filter((p: any) => p.planCheckbox == true);
      console.log(this.finalEmployeeSelection)
      const updatedEmployees = this.finalEmployeeSelection.map(employee => ({
        ...employee,
        email: '', // Initialize with empty string or default value
        paymentMethod: '',// Initialize with empty string or default value
        planSelection: ''
      }));

      console.log(updatedEmployees)
      console.log(this.employees)
      const employeesArray = this.employees as FormArray; // Cast to FormArray
      while (employeesArray.length > 0) {
        this.employees.removeAt(0); // Clear each control
      }

      updatedEmployees.forEach(employee => this.employees.push(
        this.formBuilder.group({
          customerId: [employee.customerId],
          customerName: [employee.customerName || '', Validators.required],
          email: [employee?.email || '', [Validators.required, Validators.pattern(this.CommonService.emailPattern)]],
          paymentMethod: [employee?.paymentMethod || '', Validators.required],
          planSelection: [employee?.planSelection || '', Validators.required],
          proceedWithAllPlans: [employee.proceedWithAllPlans],
          proceedWithCmpRelatedPlans: [employee.proceedWithCmpRelatedPlans],
          proceedWithEmpPaidPlans: [employee.proceedWithEmpPaidPlans],
          proceedWithNoPlans: [employee.proceedWithNoPlans],
          customerPlans: [employee.customerPlans]



        })
      ));
      updatedEmployees.forEach((employee: any) => {
        this.data1.push({ isActive: false });
      })



      console.log(this.employees)
    }
  }

  get employees(): FormArray {
    return this.employeeForm.get('employees') as FormArray;
  }
  public isGroupsNotEmpty(groups: any): boolean {

    return groups && Object.keys(groups).length > 0;
  }
  showEmployeePlans(employee: any) {

    $('#showPlansForEmployee').modal('show');
    console.log(employee)
    this.globalCustomerId = employee.value.customerId
    let selectedplans:any = employee.value.customerPlans

    console.log(selectedplans)

    let plans: any = this.getEmployeePlans.filter(emp => emp.customerId == this.globalCustomerId);
    console.log(plans)
    this.productsArray = plans[0].packages
    this.notAllowedPlans = plans[0].notAllowedPlans

    console.log(this.productsArray)

      let data: any = JSON.parse(sessionStorage.getItem("plansummary") || '[]');
      let obj = {};

    if (data.length>0) {

      data.forEach((element: any, index: any) => {

        if (element.customerId == this.globalCustomerId) {
          obj = {
            planid: element.id,
          };

          setTimeout(() => {

            const dom: HTMLElement = this.elementRef.nativeElement;
            const plan: any = dom.querySelector("#plancheck" + element.id);


            if (element.options && element.options.length > 0) {

              if (element.isBundle) {
                // const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);


                // this.renderer.setProperty(planCheck, 'checked', true);
                const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);
                this.renderer.setProperty(plan, 'checked', true);

                if (element.paidByCompany == 1) {
                  const dom: HTMLElement = this.elementRef.nativeElement;
                  // const plan: any = dom.querySelector("#plancheck" + element.id);




                  if (element.coverage) {
                    const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);
                    if (plan) {
                      plan.disabled = true;
                    }
                  }
                  else {
                    const plan = this.renderer.selectRootElement("#plancheck" + element.id, true);
                    if (plan) {
                      plan.disabled = true;
                    }
                  }
                }


              } else {
                element.products.forEach((products: any, index: any) => {
                  // const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);


                  // this.renderer.setProperty(planCheck, 'checked', true);
                  if (element.coverage) {
                    const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);


                    this.renderer.setProperty(plan, 'checked', true);
                  }
                  else {
                    const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                    this.renderer.setProperty(planCheck, 'checked', true);

                  }

                  if (element.paidByCompany == 1) {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    // const plan: any = dom.querySelector("#plancheck" + products.planLevel);


                    if (element.coverage) {
                      const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);
                      if (plan) {
                        plan.disabled = true;
                      }
                    }
                    else {
                      const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                      if (plan) {
                        plan.disabled = true;
                      }
                    }
                  }


                })
              }

            }

            else {

              if (element.isBundle) {
                const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);


                this.renderer.setProperty(plan, 'checked', true);
                // const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);

                // // console.log(planCheck)
                // this.renderer.setProperty(planCheck, 'checked', true);

                if (element.paidByCompany == 1) {
                  const dom: HTMLElement = this.elementRef.nativeElement;
                  if (element.coverage) {
                    const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);
                    if (plan) {
                      plan.disabled = true;
                    }
                  }
                  else {
                    const plan = this.renderer.selectRootElement("#plancheck" + element.id, true);
                    if (plan) {
                      plan.disabled = true;
                    }
                  }
                }


              }
              else {
                element.products.forEach((products: any, index: any) => {
                  // $("#plancheck" + products.id).click();
                  // const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                  //   console.log(planCheck)
                  // this.renderer.setProperty(planCheck, 'checked', true);
                  if (element.coverage) {
                    const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);


                    this.renderer.setProperty(plan, 'checked', true);
                  }
                  else {
                    const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                    this.renderer.setProperty(planCheck, 'checked', true);

                  }
                  if (element.paidByCompany == 1) {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    if (element.coverage) {
                      const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);
                      if (plan) {
                        plan.disabled = true;
                      }
                    }
                    else {
                      const plan = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                      if (plan) {
                        plan.disabled = true;
                      }
                    }
                  }
                })
              }
            }

            // $("#plancheck" + element.id).prop("checked", true);
            // plan.checked =true
          }, 100);

          // this.plancheckarray.push(element.id)
        }
        else {

          selectedplans.forEach((element: any, index: any) => {

            obj = {
              planid: element.id,
            };

            setTimeout(() => {

              const dom: HTMLElement = this.elementRef.nativeElement;
              const plan: any = dom.querySelector("#plancheck" + element.id);


              if (element.options && element.options.length > 0) {

                if (element.isBundle) {
                  // const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);


                  // this.renderer.setProperty(planCheck, 'checked', true);
                  const plan: any = dom.querySelector("#plancheck" + element.planId + ".coverage" + element.coverage);
                  this.renderer.setProperty(plan, 'checked', true);

                  if (element.paidByCompany == 1) {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    // const plan: any = dom.querySelector("#plancheck" + element.id);




                    if (element.coverage) {
                      const plan: any = dom.querySelector("#plancheck" + element.planId + ".coverage" + element.coverage);
                      if (plan) {
                        plan.disabled = true;
                      }
                    }
                    else {
                      const plan = this.renderer.selectRootElement("#plancheck" + element.planId, true);
                      if (plan) {
                        plan.disabled = true;
                      }
                    }
                  }


                } else {
                  element.products.forEach((products: any, index: any) => {
                    // const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);


                    // this.renderer.setProperty(planCheck, 'checked', true);
                    if (element.coverage) {
                      const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);


                      this.renderer.setProperty(plan, 'checked', true);
                    }
                    else {
                      const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                      this.renderer.setProperty(planCheck, 'checked', true);

                    }

                    if (element.paidByCompany == 1) {
                      const dom: HTMLElement = this.elementRef.nativeElement;
                      // const plan: any = dom.querySelector("#plancheck" + products.planLevel);


                      if (element.coverage) {
                        const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);
                        if (plan) {
                          plan.disabled = true;
                        }
                      }
                      else {
                        const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                        if (plan) {
                          plan.disabled = true;
                        }
                      }
                    }


                  })
                }

              }

              else {

                if (element.isBundle) {
                  console.log(element)
                  const plan: any = dom.querySelector("#plancheck" + element.planId + ".coverage" + element.coverage);
                  console.log(plan)
                  plan.click()
                  // this.renderer.setProperty(plan, 'checked', true);
                  // const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);

                  // // console.log(planCheck)
                  // this.renderer.setProperty(planCheck, 'checked', true);

                  if (element.paidByCompany == 1) {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    if (element.coverage) {
                      const plan: any = dom.querySelector("#plancheck" + element.planId + ".coverage" + element.coverage);
                      if (plan) {
                        plan.disabled = true;
                      }
                    }
                    else {
                      const plan = this.renderer.selectRootElement("#plancheck" + element.planId, true);
                      if (plan) {
                        plan.disabled = true;
                      }
                    }
                  }


                }
                else {
                  element.products.forEach((products: any, index: any) => {
                    // $("#plancheck" + products.id).click();
                    // const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                    //   console.log(planCheck)
                    // this.renderer.setProperty(planCheck, 'checked', true);
                    if (element.coverage) {
                      const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);


                      this.renderer.setProperty(plan, 'checked', true);
                    }
                    else {
                      const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                      this.renderer.setProperty(planCheck, 'checked', true);

                    }
                    if (element.paidByCompany == 1) {
                      const dom: HTMLElement = this.elementRef.nativeElement;
                      if (element.coverage) {
                        const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);
                        if (plan) {
                          plan.disabled = true;
                        }
                      }
                      else {
                        const plan = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                        if (plan) {
                          plan.disabled = true;
                        }
                      }
                    }
                  })
                }
              }

              // $("#plancheck" + element.id).prop("checked", true);
              // plan.checked =true
            }, 100);

            // this.plancheckarray.push(element.id)

          });

        }


        });
    }
    else {

      selectedplans.forEach((element: any, index: any) => {

          obj = {
            planid: element.id,
          };

          setTimeout(() => {

            const dom: HTMLElement = this.elementRef.nativeElement;
            const plan: any = dom.querySelector("#plancheck" + element.id);


            if (element.options && element.options.length > 0) {

              if (element.isBundle) {
                // const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);


                // this.renderer.setProperty(planCheck, 'checked', true);
                const plan: any = dom.querySelector("#plancheck" + element.planId + ".coverage" + element.coverage);
                this.renderer.setProperty(plan, 'checked', true);

                if (element.paidByCompany == 1) {
                  const dom: HTMLElement = this.elementRef.nativeElement;
                  // const plan: any = dom.querySelector("#plancheck" + element.id);




                  if (element.coverage) {
                    const plan: any = dom.querySelector("#plancheck" + element.planId + ".coverage" + element.coverage);
                    if (plan) {
                      plan.disabled = true;
                    }
                  }
                  else {
                    const plan = this.renderer.selectRootElement("#plancheck" + element.planId, true);
                    if (plan) {
                      plan.disabled = true;
                    }
                  }
                }


              } else {
                element.products.forEach((products: any, index: any) => {
                  // const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);


                  // this.renderer.setProperty(planCheck, 'checked', true);
                  if (element.coverage) {
                    const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);


                    this.renderer.setProperty(plan, 'checked', true);
                  }
                  else {
                    const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                    this.renderer.setProperty(planCheck, 'checked', true);

                  }

                  if (element.paidByCompany == 1) {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    // const plan: any = dom.querySelector("#plancheck" + products.planLevel);


                    if (element.coverage) {
                      const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);
                      if (plan) {
                        plan.disabled = true;
                      }
                    }
                    else {
                      const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                      if (plan) {
                        plan.disabled = true;
                      }
                    }
                  }


                })
              }

            }

            else {

              if (element.isBundle) {
                console.log(element)
                const plan: any = dom.querySelector("#plancheck" + element.planId + ".coverage" + element.coverage);
                  console.log(plan)
                  plan.click()
                // this.renderer.setProperty(plan, 'checked', true);
                // const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);

                // // console.log(planCheck)
                // this.renderer.setProperty(planCheck, 'checked', true);

                if (element.paidByCompany == 1) {
                  const dom: HTMLElement = this.elementRef.nativeElement;
                  if (element.coverage) {
                    const plan: any = dom.querySelector("#plancheck" + element.planId + ".coverage" + element.coverage);
                    if (plan) {
                      plan.disabled = true;
                    }
                  }
                  else {
                    const plan = this.renderer.selectRootElement("#plancheck" + element.planId, true);
                    if (plan) {
                      plan.disabled = true;
                    }
                  }
                }


              }
              else {
                element.products.forEach((products: any, index: any) => {
                  // $("#plancheck" + products.id).click();
                  // const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                  //   console.log(planCheck)
                  // this.renderer.setProperty(planCheck, 'checked', true);
                  if (element.coverage) {
                    const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);


                    this.renderer.setProperty(plan, 'checked', true);
                  }
                  else {
                    const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                    this.renderer.setProperty(planCheck, 'checked', true);

                  }
                  if (element.paidByCompany == 1) {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    if (element.coverage) {
                      const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);
                      if (plan) {
                        plan.disabled = true;
                      }
                    }
                    else {
                      const plan = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                      if (plan) {
                        plan.disabled = true;
                      }
                    }
                  }
                })
              }
            }

            // $("#plancheck" + element.id).prop("checked", true);
            // plan.checked =true
          }, 100);

          // this.plancheckarray.push(element.id)

      });

    }

      let dataLife: any = JSON.parse(sessionStorage.getItem("plansummaryLife") || '[]');

      if (dataLife) {

        dataLife.forEach((element: any, index: any) => {

          setTimeout(() => {

            const dom: HTMLElement = this.elementRef.nativeElement;
            // const plan: any = dom.querySelector("#planCheckLife" + element.planCoverage+"-"+coverage);



            element.products.forEach((products: any, index: any) => {
              // $("#plancheck" + products.id).click();
              if (element.coverage == 'MEMBER') {
                element.coverage = 'MEMBER'
                const planCheck = this.renderer.selectRootElement("#planCheckLife" + element.planCoverage + "-" + element.coverage, true);

                this.renderer.setProperty(planCheck, 'checked', true);
              } else {
                element.coverage = 'SPOUSE'
                const planCheck = this.renderer.selectRootElement("#planCheckLife" + element.planCoverage + "-" + element.coverage, true);

                this.renderer.setProperty(planCheck, 'checked', true);
                const planCheck1 = this.renderer.selectRootElement("#planCheckLife" + element.planCoverage + "-" + 'MEMBER', true);

                this.renderer.setProperty(planCheck1, 'checked', true);
              }
              // if(element.coverage=='MEMBER'){
              //   element.coverage='MEMBER'
              // }else{
              //   element.coverage='SPOUSE'
              // }
              // const planCheck = this.renderer.selectRootElement("#planCheckLife" + element.planCoverage+"-"+element.coverage, true);

              // // console.log(planCheck)
              // this.renderer.setProperty(planCheck, 'checked', true);
            })


            // $("#plancheck" + element.id).prop("checked", true);
            // plan.checked =true
          }, 100);

          // this.plancheckarray.push(element.id)
        });

      }



  }
  public isParentsGreaterThanOne(groups: any): boolean {
    // console.log(Object.keys(groups), Object.keys(groups).length > 1)
    return groups && Object.keys(groups).length > 1;
  }

  public showPricing = false;


  getStatus(published, restricted) {
    let data = -1;
    if (published) {
      if (restricted) {
        data = 2
      }
      else {
        data = 1
      }

    }
    else {
      data = 0
    }
    return data
  }

  public colors = { 0: "#FF3131", 1: "#37FBB3", 2: "black" }
  public text = { 0: "Unpublished", 1: "Published", 2: "Published but Restricted" }

  getColorForPlans(published, restricted) {

    const pubStatus = { 0: false, 1: true }
    // console.log(pubStatus[published], restricted)
    let data = this.getStatus(pubStatus[published], restricted)
    return this.colors[data]
  }

  getTextForTooltip(published, restricted) {
    const pubStatus = { 0: false, 1: true }
    let data = this.getStatus(pubStatus[published], restricted)
    return this.text[data]
  }

  getColorForPlans1(published, restricted) {

    let data: any = this.getStatus(published, restricted)
    const color = this.colors[data];
    return color;
  }

  getTextForTooltip1(published, restricted) {
    let data: any = this.getStatus(published, restricted)
    const text = this.text[data]
    return text
  }

  planCheckboxplans(productName: any, planKey: any, parentId: any, planName: any, planId: any, event: any) {
    let disabled = true
    if (event.target.checked) {

      console.log(planName)
      this.allplansArray[productName][planName].planCheckbox = true;
      this.changePlanCheckedValuesPlans(productName, planKey, parentId)
      if (planName.includes("La Vie")) {
        const dom: HTMLElement = this.elementRef.nativeElement;
        // const plan: any = dom.querySelector(`#plancheck792`)
        const plan: any = dom.querySelector("#planCheckbox18");
        setTimeout(() => {
          plan.click()
          this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
        }, 1000);




      }
    }
    else {
      this.allplansArray[productName][planName].planCheckbox = false;
      this.changePlanCheckedValuesPlans(productName, planKey, parentId)
    }
    this.checkForAllPlansCheckedPlans(productName, planKey, parentId)
    this.checkForClassic()
  }

  checkForClassic() {
    let flag = 0

    Object.keys(this.allplansArray).forEach((pack: any) => {
      if (this.allplansArray[pack].packageId == 1) {
        Object.keys(this.allplansArray[pack]).forEach((p) => {
          if (typeof this.allplansArray[pack][p] === 'object' && p.includes("Classic") && this.allplansArray[pack][p]['parentId'] && this.allplansArray[pack][p]['planCheckbox'] === true) {
            flag = flag + 1
          }
        });
      }
    });

    if (flag >= 1) {
      this.showPricing = true;
    }
    else {
      this.showPricing = false;
    }
  }

  toggleAllPlans1(productName: any, productId: any, event: any) {
    console.log(productName, productId, event.target.checked)

    if (event.target.checked) {
      // this.plansError = false;
      this.changePackageCheckedValues1(productName, productId, true)

    }
    else {
      this.changePackageCheckedValues1(productName, productId, false)

    }

    console.log({ plansArray: this.allplansArray })

    this.checkForClassic()


  }
  changePackageCheckedValues1(productName: any, productId: any, bool: boolean) {
    this.allplansArray[productName]['packageCheckbox'] = bool;
    Object.keys(this.allplansArray[productName]).forEach((p, id) => {
      if (typeof this.allplansArray[productName][p] === 'object') {
        this.allplansArray[productName][p]['planCheckbox'] = bool;
      }
    })

    Object.keys(this.allplansArray[productName]).forEach((p, id) => {
      if (typeof this.allplansArray[productName][p] === 'object' && this.allplansArray[productName][p].isParent) {
        this.allplansArray[productName][p].checked = bool;
      }
    })
    console.log({ plansArray: this.allplansArray })

  }
  checkForAllPlansCheckedPlans(productName, planKey: any, parentId) {

    let planFlag = Object.keys(this.allplansArray[productName]).some((p) => {
      return (typeof this.allplansArray[productName][p] === 'object' && this.allplansArray[productName][p]['parentId'] === parentId && this.allplansArray[productName][p]['planCheckbox'] === false)
    });
    this.allplansArray[productName][planKey].checked = !planFlag;


    let flag = Object.keys(this.allplansArray[productName]).some((p) => {
      return (typeof this.allplansArray[productName][p] === 'object' && this.allplansArray[productName][p]['parentId'] != 'null' && this.allplansArray[productName][p]['planCheckbox'] === false)
    });


    this.allplansArray[productName].packageCheckbox = !flag;


    console.log({ plansAyyay: this.allplansArray })
  }

  changePlanCheckedValuesPlans(productName: any, planKey: any, parentId: any) {
    this.allplansArray[productName].packageCheckbox = false;
    this.allplansArray[productName][planKey].checked = false;
    this.checkForAllPlansCheckedPlans(productName, planKey, parentId)
    this.checkForClassic()

    console.log(this.allplansArray)

  }

  public onCheckboxChange(
    e: any,
    allowMultiple: any,
    disallowedPlanLevels: any,
    options: any,
    pname: any,
    groupname: any,
    plancoverage: any,
    planprice: any,
    gst: any,
    hst: any,
    pst: any,
    event: any,
    event1: any,
    packageindex: any,
    groupindex: any,
    planindex: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    coverage: any
  ) {
    // e.preventDefault();
    // let multiple = allowMultiple ? Boolean(allowMultiple.data[0]) : false;

    let multiple = allowMultiple == true ? true : false;

    console.log(multiple)

    if (e.target.checked) {
      //unselect all checkboxes with same id(fix for single.couple and family multiple seelction)
      const dom: HTMLElement = this.elementRef.nativeElement;

      const samePlanIdElements = dom.querySelectorAll('#' + e.target.id);
      console.log(samePlanIdElements)

      for (let i = 0; i < samePlanIdElements.length; i++) {
        let elem = samePlanIdElements[i];
        let element: any = elem;
        //  console.log(elem)

        if (element.checked) {
          element.checked = false;
          this.unselectplan(elem);

        }
      }
      e.target.checked = true
    } else {
      //      this.planCoverageName = ''
      // this.insuranceplanid =''
    }

    // console.log(multiple)

    // console.log(plan)
    // console.log(product)


    //this.consoleMessage(disallowedPlanLevels)

    console.log(disallowedPlanLevels)

    if (disallowedPlanLevels != null) {
      //this.consoleMessage(disallowedPlanLevels)
      let disallowed_plans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;
      const disallowed_elements = dom1.querySelectorAll(
        ".plansscreen input[type='checkbox']"
      );

      // disallowed_elements.forEach((elem: any) => {

      // console.log(disallowed_elements)

      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];
        // elementcv.checked=false

        if (!elem.attributes.data) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        //this.consoleMessage(plandetailsobj)

        // console.log(disallowed_plans)   //[1,10,19,20,21]
        // console.log(plandetailsobj[12])  //[24]
        // console.log(plandetailsobj[20]) //[10]
        // console.log(plandetailsobj[12])  //[24]
        // console.log(plandetailsobj[13])
        // console.log(plandetailsobj[19])
        // console.log(plandetailsobj[21])


        // console.log(typeof plandetailsobj[21])
        // console.log(plandetailsobj[12])
        // console.log(plandetailsobj[13])
        // console.log(plandetailsobj[20])


        let isBundle = plandetailsobj[21] == "true" ? true : false
        // console.log(isBundle)
        if (e.target.checked) {

          if (!elem.disabled) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  console.log("1")
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  console.log("2")

                  console.log(elem)

                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            } else {

              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  console.log(elem)

                  if (elem.checked) {
                    console.log("checkehd")
                    elem.checked = false;
                    this.unselectplan(elem);
                  }

                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  console.log("4")
                  console.log(elem)
                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            }
          }
          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem);
                  // elem.disabled =true
                }
              }

            }
          }
        }
        else {
          if (elem.disabled) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              }
            }
            if (isBundle) {
              if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            }

            // else {
            //   if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
            //     //  elem.checked=false
            //     elem.disabled = false;
            //   }
            // }
          }
          if (elem.checked) {

            console.log("elechecked")

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  console.log("elechecked1")
                  this.unselectplan(elem);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  console.log("elechecked2")
                  this.unselectplan(elem);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem);
                  // elem.disabled =true
                }
              }

            }
          }
        }
      }
    }

    let sameplanclassname = `newPlan${plan.id}`
    let covergaClassNmae = `coverage${coverage.toUpperCase()}` // //////this.consoleMessage(e)
    let classname = e.target.className.replace(sameplanclassname, '').replace(covergaClassNmae, '');
    classname = classname.split(' ').join('.').replaceAll('..', '.');

    console.log(classname)
    console.log(sameplanclassname)
    // //////this.consoleMessage(classname)
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll(classname);
    // const elements = dom.querySelectorAll(e.target.className);

    // const samePlanElements = dom.querySelectorAll('.' + sameplanclassname);

    // //////this.consoleMessage(elements);

    let element: any;
    let elementcv: any;

    if (!multiple) {
      console.log("multiple elesehere")
      if (e.target.checked) {

        console.log(elements)
        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i];
          element = elem;

          if (element.checked) {

            this.unselectplan(elem);
            element.checked = false;
          }
        }

        e.checked = true;
        e.target.checked = true;
      } else {
      }
    }
    else {

      // console.log("elesehere")
      if (e.target.checked) {


        // for (let i = 0; i < samePlanElements.length; i++) {
        //   let elem = samePlanElements[i];
        //   element = elem;

        //   if (element.checked) {

        //     this.unselectplan(elem);
        //     element.checked = false;
        //   }
        // }

        e.checked = true;
        e.target.checked = true;
      } else {
      }
      // alert("!")
      //no checking for other checkboxes you can selet multiple
    }
    setTimeout(() => {
      if (e.target.checked) {
        this.selectplan(e.target, options, plan, product, pckage, group, disallowedPlanLevels);
      } else {
        this.unselectplan(e.target);
      }
    }, 10);
  }
 public selectplan(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    disallowedPlanLevels: any
  ) {

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');

    if (options && options.length > 0) {
      sessionStorage.setItem('options', JSON.stringify(options));
    }
    // if (options && options.length > 0) {
    //   let coverage = product.planCoverage;

    //   coverage = ['SINGLE', 'COUPLE', 'FAMILY'].includes(coverage)
    //     ? coverage
    //     : null;
    //   ////this.consoleMessage(obj)
    //   this.productobj = {
    //     id: product.id,
    //     productId: product.productId,
    //     name: product.name,
    //     planProductId: product.planProductId,
    //     price: this._decimalPipe
    //       .transform(product.price1 || product.price, '1.2-2')
    //       ?.replace(/,/g, ''),
    //     tax: this._decimalPipe
    //       .transform(
    //         product.calculatedTax ? product.calculatedTax.tax : 0,
    //         '1.2-2'
    //       )
    //       ?.replace(/,/g, ''),
    //     total: this._decimalPipe
    //       .transform(
    //         product.calculatedTax ? product.calculatedTax.total : 0,
    //         '1.2-2'
    //       )
    //       ?.replace(/,/g, ''),
    //     tax_details:
    //       product.bundledTaxes && product.bundledTaxes.length > 0
    //         ? product.bundledTaxes
    //         : product.taxesDataJSON,
    //     calculatedTax: product.calculatedTax,
    //     bundledProducts: product.bundledProducts,
    //     planCoverage: product.planCoverage,
    //     planLevel: product.planlevel ? product.planlevel.id : '',
    //     planLevelParent: product.planlevel ? product.planlevel.parentId : '',
    //     description: product.description,
    //     coverage: coverage,
    //   };

    //   let obj1: any = {
    //     packageId: plan.packageId,
    //     packageName: pckage.name,

    //     planproductname: this.productobj.name,

    //     groupid: plan.planLevel,
    //     groupName: group.name,
    //     id: plan.id,
    //     name: plan.name,
    //     planLevel: plan.planLevel ? plan.planLevel : group.id,
    //     planLevelParent: group.parentId,
    //     fusebillPlanID: plan.fusebillId,
    //     planFrequencyID: plan.frqMonthly,
    //     isBundle: plan.isBundle,
    //     coverage: coverage,
    //     planCoverage: product.planCoverage,
    //     bundledProducts: [],
    //     products: [],
    //   };
    //   obj1.products.push(this.productobj);
    //   this.planobjdata = obj1;

    //   this.openplanoptions(elementcv, options, plan, product);
    // }

    // else {
    let obj: any = {
      isBundle: plan.isBundle,
      disallowedPlanLevels: disallowedPlanLevels,
      // enrollmentDate: moment(
      //   this.userForm.get("planenrollmentdate").value,
      //   "MM-DD-YYYY"
      // ).format("YYYY-MM-DD"),
      enrollmentDate: '',
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(product.calculatedTax.price),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(product.calculatedTax.price),
      amountUI:
        '$' +
        this._decimalPipe.transform(product.calculatedTax.price, '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      version: plan.version,
      description: plan.description,
      insuranceType: plan.insuranceType,
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    let coverage = product.planCoverage;

    coverage = ['SINGLE', 'COUPLE', 'FAMILY'].includes(coverage)
      ? coverage
      : null;
    ////this.consoleMessage(obj)
    this.productobj = {
      id: product.id,
      productId: product.productId,
      name: product.name,
      planProductId: product.planProductId,
      price: this._decimalPipe
        .transform(product.price1 || product.price, '1.2-2')
        ?.replace(/,/g, ''),
      tax: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.tax : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      total: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.total : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      tax_details:
        product.bundledTaxes && product.bundledTaxes.length > 0
          ? product.bundledTaxes
          : product.taxesDataJSON,
      calculatedTax: product.calculatedTax,
      bundledProducts: product.bundledProducts,
      planCoverage: product.planCoverage,
      planLevel: product.planlevel ? product.planlevel.id : '',
      planLevelParent: product.planlevel ? product.planlevel.parentId : '',
      description: product.description,
      coverage: coverage,
    };

    let obj1: any = {
      packageId: plan.packageId,
      packageName: pckage.name,

      planproductname: this.productobj.name,

      groupid: plan.planLevel,
      groupName: group.name,
      id: plan.id,
      name: plan.name,
      planLevel: plan.planLevel ? plan.planLevel : group.id,
      planLevelParent: group.parentId,
      fusebillPlanID: plan.fusebillId,
      planFrequencyID: plan.frqMonthly,
      isBundle: plan.isBundle,
      coverage: coverage,
      planCoverage: product.planCoverage,
      bundledProducts: [],
      products: [],
    };
    obj1.products.push(this.productobj);
    //this.consoleMessage(obj1)

    this.addtoplansummary(obj, obj1);
    setTimeout(() => {


      // this.openplanoptions(elementcv, options, plan, product)

 this.openplanoptions(elementcv)
    }, 1000);
    // }
  }
  public unselectplan(elementcv: any) {
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    let obj = {
      customerId: this.globalCustomerId,
      enrollmentDate: '',
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI: '$' + this._decimalPipe.transform(plandetailsobj[3], '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    this.removeplansummary(obj);
    setTimeout(() => {


      this.openplanoptions(elementcv)


    }, 1000);
  }

  public addtoplansummary(obj: any, obj1: any) {

      let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');
    if (obj.customerId == planSummary.customerId) {
      this.logger.log(obj1);
      this.logger.log(planSummary)
      //this.logger.log("addroplansummaryplans")
      //this.logger.log(planSummary.length)
      //this.logger.log(obj.id)
      this.logger.log('obj', obj);

      this.addtoslectplans(obj.id, planSummary.length);
      planSummary.push(obj);

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;
        obj['gstPrice'] = parseFloat(
          this._decimalPipe.transform(gstprice, '1.2-2')
        );
      } else {
        obj['gstPrice'] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;

        obj['hstPrice'] = parseFloat(
          this._decimalPipe.transform(hstprice, '1.2-2')
        );
      } else {
        obj['hstPrice'] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;
        obj['pstPrice'] = parseFloat(
          this._decimalPipe.transform(pstprice, '1.2-2')
        );
      } else {
        obj['pstPrice'] = 0;
      }

      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;
        obj['qstPrice'] = parseFloat(
          this._decimalPipe.transform(qstprice, '1.2-2')
        );
      } else {
        obj['qstPrice'] = 0;
      }

      obj['taxUI'] = '';
      if (obj['gstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['gstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
            '&nbsp;(GST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['pstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['pstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
            '&nbsp;(PST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['qstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['qstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
            '&nbsp;(QST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['hstCheck']) {
        obj['taxUI'] += '<span> ';
        if (obj['hstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
            '&nbsp;(HST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (
        !obj['hstCheck'] &&
        !obj['gstCheck'] &&
        !obj['pstCheck'] &&
        !obj['qstCheck']
      ) {
        obj['taxUI'] += '<span>-';

        obj['taxUI'] += '</span>';
      }

      // //this.logger.log(object["taxUI"])

      obj['tax'] = parseFloat(
        this._decimalPipe.transform(
          obj1.products.reduce((acc, calculatedTax) => {
            return acc + calculatedTax.tax;
          }, 0),
          '1.2-2'
        )
      );

      // obj["products"] =obj1
      obj['coverage'] = obj1.coverage;
      obj['planCoverage'] = obj1.planCoverage;
      obj['planLevelParent'] = obj1.planLevelParent;
      obj['planproductname'] = obj1.planproductname;

      obj['products'] = obj1.products;
      obj['version'] = obj1.version;
      obj['customerId'] = this.globalCustomerId

      this.logger.log(obj.planPrice);
      this.logger.log(gstprice);
      this.logger.log(hstprice);
      this.logger.log(pstprice);

      this.logger.log(qstprice);
      let pricecal = obj1.products.reduce((acc, calculatedTax) => {
        return acc + calculatedTax.total;
      }, 0);
      obj['totalPrice'] = pricecal;

      obj['totalUI'] = '$' + this._decimalPipe.transform(pricecal, '1.2-2');

      obj['total'] = this._decimalPipe.transform(pricecal, '1.2-2');

      this.logger.log(obj1);

      obj['skuTotalPrice'] = obj1.products.reduce((acc, calculatedTax) => {
        return acc + calculatedTax.total;
      }, 0);

      let updatedSum = this.addtosum(obj.totalPrice);
      this.planssummarymain = [];
      this.planssummaryopt = [];
      console.log({ planSummary })

      planSummary.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });

      this.logger.log(obj1);

      this.plansskumain.push(obj1);

      sessionStorage.setItem('plansskumain', JSON.stringify(this.plansskumain));
      sessionStorage.setItem(
        'plansummarymain',
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        'plansummaryopt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('plansummary', JSON.stringify(planSummary));
      console.log(JSON.parse(sessionStorage.getItem('plansummarymain')));
      if (planSummary.length > 0) {
      } else {
      }
      // if (updatedSum > 0) {
      //   this.cartcheckvalue = false;
      // } else {
      //   this.cartcheckvalue = true;
      // }

      setTimeout(() => {
        this.planssummarymain =
          JSON.parse(sessionStorage.getItem('plansummarymain')) || '';

        var total = 0;
        for (let i = 0; i < this.planssummarymain.length; i++) {
          if (obj.planproductname.includes("La Vie")) {

            if (this.planssummarymain[i].planLevel == 18) {

              if (this.planssummarymain[i].coverage == obj.coverage) {

              } else {
                const dom: HTMLElement = this.elementRef.nativeElement;
                // const plan: any = dom.querySelector(`#plancheck792`)
                const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
                setTimeout(() => {
                  plan.click()
                  this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan.", "");
                }, 1000);
              }
              break;
            }
            else {

              const dom: HTMLElement = this.elementRef.nativeElement;
              // const plan: any = dom.querySelector(`#plancheck792`)
              const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);

              console.log(plan)
              setTimeout(() => {
                plan.click()
                this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan.", "");
              }, 1000);
            }
          }
        }

        for (let i = 0; i < this.planssummarymain.length; i++) {

          total += parseFloat(this.planssummarymain[i].skuTotalPrice);
        }

        this.logger.log(total);

        // this.planAmount = this._decimalPipe
        //   .transform(total, '1.2-2')
        //   .replace(/,/g, '');
        // sessionStorage.setItem('totalAmount', this.planAmount);

        // if (this.planAmount > 0) {
        //   this.cartcheckvalue = false;
        // } else {
        //   this.cartcheckvalue = true;
        // }
      }, 100);
    }
  }

  public removeplansummary(obj: any) {
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary'));

    //  //this.logger.log("Beforeremoving")
    //this.logger.log(planSummary)
    //this.logger.log("removeingobject")
    //this.logger.log(obj)

    console.log(obj)

    for (let i = 0; i < planSummary.length; i++) {
      if (planSummary[i].customerId == obj.customerId) {

        // //this.logger.log(obj.name)
        if (obj.planLevel == 15) {
          for (let i = 0; i < planSummary.length; i++) {

            if (planSummary[i].planLevel == 18) {
              planSummary[i].options = []
            }

          }

        }

        if (planSummary) {
          //this.logger.log("removeinplanid"+obj.id)
          let index = this.getslectedplans(obj.id);
          //this.logger.log(index)

          console.log(index)

          if (index > -1) {
            planSummary.splice(index, 1);
            //this.logger.log("afterremove")
            //this.logger.log(planSummary)
          } else {
            return;
          }

          // //this.logger.log(planSummary)
          // //this.logger.log(planSummary.length)
          //this.logger.log("beforeremoveplans")
          let selectedPlans = JSON.parse(sessionStorage.getItem('selectedPlans'));
          var newselectedplans = {};
          for (let i = 0; i < planSummary.length; i++) {
            newselectedplans[planSummary[i].id] = i;
          }

          //this.logger.log("newselectedPlans")
          //this.logger.log(newselectedplans)
          sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));
          // this.removeslectplans(obj.id,planSummary.length)

          let gstprice = 0;
          let hstprice = 0;
          let pstprice = 0;
          let qstprice = 0;

          if (obj.gst > 0) {
            gstprice = obj.planPrice * obj.gst;
            obj['gstPrice'] = parseFloat(
              this._decimalPipe.transform(gstprice, '1.2-2')
            );
          } else {
            obj['gstPrice'] = 0;
          }

          if (obj.hst > 0) {
            hstprice = obj.planPrice * obj.hst;

            obj['hstPrice'] = parseFloat(
              this._decimalPipe.transform(hstprice, '1.2-2')
            );
          } else {
            obj['hstPrice'] = 0;
          }

          if (obj.pst > 0) {
            pstprice = obj.planPrice * obj.pst;
            obj['pstPrice'] = parseFloat(
              this._decimalPipe.transform(pstprice, '1.2-2')
            );
          } else {
            obj['pstPrice'] = 0;
          }
          if (obj.qst > 0) {
            qstprice = obj.planPrice * obj.qst;
            obj['qstPrice'] = parseFloat(
              this._decimalPipe.transform(qstprice, '1.2-2')
            );
          } else {
            obj['qstPrice'] = 0;
          }

          obj['taxUI'] = '';
          if (obj['gstCheck']) {
            obj['taxUI'] += '<span>';
            if (obj['gstPrice'] == 0) {
              obj['taxUI'] += '-';
            } else {
              obj['taxUI'] +=
                '$' +
                this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
                '&nbsp;(GST)';
            }
            obj['taxUI'] += '</span>';
          }

          if (obj['pstCheck']) {
            obj['taxUI'] += '<span>';
            if (obj['pstPrice'] == 0) {
              obj['taxUI'] += '-';
            } else {
              obj['taxUI'] +=
                '$' +
                this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
                '&nbsp;(PST)';
            }
            obj['taxUI'] += '</span>';
          }

          if (obj['qstCheck']) {
            obj['taxUI'] += '<span>';
            if (obj['qstPrice'] == 0) {
              obj['taxUI'] += '-';
            } else {
              obj['taxUI'] +=
                '$' +
                this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
                '&nbsp;(QST)';
            }
            obj['taxUI'] += '</span>';
          }

          if (obj['hstCheck']) {
            obj['taxUI'] += '<span> ';
            if (obj['hstPrice'] == 0) {
              obj['taxUI'] += '-';
            } else {
              obj['taxUI'] +=
                '$' +
                this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
                '&nbsp;(HST)';
            }
            obj['taxUI'] += '</span>';
          }

          if (
            !obj['hstCheck'] &&
            !obj['gstCheck'] &&
            !obj['pstCheck'] &&
            !obj['qstCheck']
          ) {
            obj['taxUI'] += '<span>-';

            obj['taxUI'] += '</span>';
          }

          // //this.logger.log(object["taxUI"])

          obj['tax'] = parseFloat(
            this._decimalPipe.transform(
              gstprice + hstprice + pstprice + qstprice,
              '1.2-2'
            )
          );
          (obj['totalPrice'] =
            obj.planPrice + gstprice + hstprice + pstprice + qstprice),
            (obj['totalUI'] =
              '$' +
              this._decimalPipe.transform(
                obj.planPrice + gstprice + hstprice + pstprice + qstprice,
                '1.2-2'
              ));

          obj['total'] = parseFloat(
            this._decimalPipe.transform(
              obj.planPrice + gstprice + hstprice + pstprice + qstprice,
              '1.2-2'
            )
          );

          let updatedSum = this.removetosum(obj.totalPrice);
          this.planssummarymain = [];
          this.planssummaryopt = [];

          planSummary.forEach((element: any) => {
            if (element.packagename != 'Opt-in') {
              this.planssummarymain.push(element);
            } else {
              this.planssummaryopt.push(element);
            }
          });

          sessionStorage.setItem(
            'plansummarymain',
            JSON.stringify(this.planssummarymain)
          );
          sessionStorage.setItem(
            'plansummaryopt',
            JSON.stringify(this.planssummaryopt)
          );

          sessionStorage.setItem('plansummary', JSON.stringify(planSummary));

          if (planSummary.length > 0) {
            // this.plansnexttab = false;
          } else {
            // this.plansnexttab = true;
          }
          // if (updatedSum > 0) {
          //   this.cartcheckvalue = false;
          // } else {
          //   this.cartcheckvalue = true;
          // }
        }

        setTimeout(() => {
          this.planssummarymain =
            JSON.parse(sessionStorage.getItem('plansummarymain')) || '';

          var total = 0;
          for (let i = 0; i < this.planssummarymain.length; i++) {
            total += parseFloat(this.planssummarymain[i].skuTotalPrice);
          }

          this.logger.log(total);

          // this.planAmount = this._decimalPipe
          //   .transform(total, '1.2-2')
          //   .replace(/,/g, '');
          // sessionStorage.setItem('totalAmount', this.planAmount);
        }, 100);
      }
    }
  }

  public addtoslectplans(planid: number, plansumamryindex: number) {
    //this.logger.log("beforeaddtoplans")
    //this.logger.log(planid)
    //this.logger.log(plansumamryindex)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    //this.logger.log(selectedPlans)
    selectedPlans[planid] = plansumamryindex;
    //this.logger.log("afteraddtoplans")
    //this.logger.log(selectedPlans)
    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }
  public removeslectplans(planid: number, plansumamryindex: number) {
    //this.logger.log("beforeremoveplans")
    let selectedPlans = JSON.parse(sessionStorage.getItem('selectedPlans'));

    //this.logger.log(selectedPlans)
    delete selectedPlans[planid];

    for (const planid in selectedPlans) {
      //this.logger.log(planid)
      //this.logger.log(selectedPlans[planid])

      if (selectedPlans[planid] != 0) {
        selectedPlans[planid] = selectedPlans[planid] - 1;
        if (selectedPlans[planid]) {
        }
      }
    }
    //this.logger.log("adjustedselectedPlans")
    //this.logger.log(selectedPlans)
    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }

  public getslectedplans(planid: number) {
    //this.logger.log(planid)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    //this.logger.log(selectedPlans)
    return selectedPlans[planid];
  }
  public addtosum(amount: any) {
    this.logger.log('addtosum' + amount);

    // amount = Math.round((amount + Number.EPSILON) * 100) / 100;

    let selectedPlansAmount = parseFloat(
      sessionStorage.getItem('totalAmount') || '0.00'
    );

    selectedPlansAmount = selectedPlansAmount + parseFloat(amount);

    this.logger.log('selectedPlansAmount' + selectedPlansAmount);
    sessionStorage.setItem(
      'totalAmount',
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        .replace(/,/g, '')
    );

    sessionStorage.setItem(
      'totalAmountUI',
      '$' +
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        .replace(/,/g, '')
    );

    // this.planAmount = this._decimalPipe
    //   .transform(selectedPlansAmount, '1.2-2')
    //   .replace(/,/g, '');

    return selectedPlansAmount;
  }

  public removetosum(amount: number) {
    let selectedPlansAmount = parseFloat(
      sessionStorage.getItem('totalAmount').replace(/,/g, '')
    );

    selectedPlansAmount = selectedPlansAmount - amount;
    sessionStorage.setItem(
      'totalAmount',
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        .replace(/,/g, '')
    );
    sessionStorage.setItem(
      'totalAmountUI',
      '$' +
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        .replace(/,/g, '')
    );

    // this.planAmount = this._decimalPipe
    //   .transform(selectedPlansAmount, '1.2-2')
    //   .replace(/,/g, '');
    return selectedPlansAmount;
  }

  public openplanoptions(elementcv) {
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');

    let modifiedOptions = [];

    // this.plandetailsobjvalue = plandetailsobj;
    // this.logger.log(plandetails);
    // this.logger.log(product.id);

    this.plandetailsobjvalue = plandetails;
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');
    let optionsValue = JSON.parse(sessionStorage.getItem('options') || '[]');

    for (let i = 0; i < planSummary.length; i++) {

      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("Medcan")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("Medcan") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });
        optionsValue = filteredData


      }
      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("La Vie")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("La Vie") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });
        optionsValue = filteredData

      }
      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("La Vie") && planSummary[i].planproductname.includes("Medcan")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("La Vie") || option.name.includes("Medcan") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });

        optionsValue = filteredData


      }
    }

    optionsValue.forEach((element) => {
      element.planOptionsValues.forEach((options) => {
        options.planOptionName = element.name;
        options.json = JSON.stringify(options);
      });

      modifiedOptions.push(element);
    });

    this.optionstitle = modifiedOptions;
    // this.showoptions = true;
    // alert("startrhetre")
    // setTimeout(() => {
    //   $('#showplanoptions-modal').modal('show');
    // }, 1000);
  }
  public planoptionselection(event, optionvalue, optionid, optionvalueid) {
    // $(".optionselectionmethod-" + optionid)
    //   .not(this)
    //   .prop("checked", false);

    // $("#planselectionvalue-" + optionvalueid + "-" + optionid).prop(
    //   "checked",
    //   true
    // );

    this.optionmessage = '';
  }

  public confirmoptionsselection() {
    let optionumber = $('#optionumber').val();
    this.logger.log('plandetailsobj', $('#plandetailsobj').val());

    let plandetailsobj = $('#plandetailsobj').val().split('##');

    let array = [];

    let optionarray = [];

    let checkvalue = true;

    for (let i = 1; i <= optionumber; i++) {
      checkvalue =
        checkvalue && $('.optionselectionmethod-' + i + ':checked').val();
    }

    if (!checkvalue) {
      this.optionmessage = this.lang.Please_select_all_plan_options;
      return;
    } else {
      this.optionmessage = '';
    }

    $('#showplanoptions-modal').modal('hide');

    if (sessionStorage.getItem('maritalStatus') == plandetailsobj[2]) {
    } else {
      if (sessionStorage.getItem('brokerType') == 'EXECUTIVE') {
        $('#insuranceconfirmation-modal').modal('show');
      }
    }

    for (let i = 1; i <= optionumber; i++) {
      let optionobj: any = {};

      let selectedOptionValues = JSON.parse(
        $('.optionselectionmethod-' + i + ':checked').val()
      );
      // //this.logger.log(selectedOptionValues)
      optionobj = selectedOptionValues;

      optionobj.name = selectedOptionValues.planOptionName;
      optionobj.value = selectedOptionValues.value;
      optionobj.planOptionsValueId = selectedOptionValues.planOptionsValueId;

      optionarray.push(optionobj);
    }

    // let plandetailsobj = $("#plandetailsobj").val().split(",");

    let obj = {
      enrollmentDate: '',
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI: '$' + this._decimalPipe.transform(plandetailsobj[3], '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: optionarray || [],
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
        // elementcv.checked =false
      }
    }

    let obj1 = {};
    this.logger.log(obj);
    // this.addtoplansummary(obj, this.planobjdata);
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    for (let i = 0; i < planSummary.length; i++) {
      if (planSummary[i].planLevel == 18) {
        planSummary[i].options = obj.options
      }
    }

    console.log(planSummary)
    sessionStorage.setItem('plansummary', JSON.stringify(planSummary));
    sessionStorage.setItem('plansummarymain', JSON.stringify(planSummary));
  }

  public closeoptionsselection() {
    $('#showplanoptions-modal').modal('hide');
    let plandetailsobj = $('#plandetailsobj').val().split('##');

    this.logger.log(plandetailsobj[19]);
    // this.logger.log(plandetailsobj[20])

    $('#plancheck' + plandetailsobj[19]).prop('checked', false);

    let optionumber = $('#optionumber').val();

    $('#showplanoptions-modal').modal('hide');

    for (let i = 1; i <= optionumber; i++) {
      $('.optionselectionmethod-' + i + ':checked').prop('checked', false);
    }
  }
  // Add a new employee to the FormArray
  // addEmployee1(employee?: any): void {
  //   let array = []

  //     this.employees.push(
  //       this.formBuilder.group({
  //         customerName: [employee?.customerName, Validators.required],
  //         email: [employee?.email || '', [Validators.required, Validators.email]],
  //         paymentMethod: [employee?.paymentMethod || '', Validators.required]
  //       })
  //     );


  //   console.log(this.employees)
  // }

  // Remove an employee
  removeEmployee(index: number): void {
    this.employees.removeAt(index);
  }

  // Submit the form
  onSubmit(): void {

    let plansummarymain = JSON.parse(sessionStorage.getItem("plansummarymain")) || "";
    if (this.employeeForm.valid) {
      console.log('Employee Data:', this.employeeForm.value);
    } else {
      console.log('Form is invalid');
    }

    let selectedEmployeeIds = []

    console.log(this.employeeForm.value.employees)

    this.employeeForm.value.employees.forEach((source) => {
      // Find the target object with the same customerid
      let target = this.terminateAllDetails.find((item) => item.customerId === source.customerId);

      // If found, push the value into the target's 'values' array


      const plans = [
        "proceedWithEmpPaidPlans",
        "proceedWithCmpRelatedPlans",
        "proceedWithAllPlans",
        "proceedWithNoPlans",
      ];

      plans.forEach((plan) => {
        source[plan] = source.planSelection === plan;
      });
      console.log(source)

      selectedEmployeeIds.push(source.customerId)


      if (target) {
        Object.assign(target, source);

      }
    });

    plansummarymain.forEach((source) => {
      // Find the target object with the same customerid
      let target = this.terminateAllDetails.find((item) => item.customerId === source.customerId);

      // If found, push the value into the target's 'values' array
      if (target) {
        // Initialize the plans array if it doesn't exist
        if (!target.plans) {
          target.plans = [];
        }

        // Add the source to the plans array
        target.plans.push(source);
      }

      // if (target) {
      //   let plans = []
      //   plans.push(source)

      //   console.log(plans)
      //   source["plan"] = plans
      //   Object.assign(target, source["plan"]);

      // }
    });

    console.log(this.terminateAllDetails);



    this.terminateAllDetails.forEach(cust => {
      cust.proceedWithGreenshield = cust.proceedWithGreenshield ? this.terminationformDetails.get('proceedWithGreenshield').value : cust.proceedWithGreenshield;
      cust.proceedWithRefund = cust.proceedWithRefund ? this.terminationformDetails.get('proceedWithRefund').value : cust.proceedWithRefund;
      cust.proceedWithSmartchoice = cust.proceedWithSmartchoice ? this.terminationformDetails.get('proceedWithSmartchoice').value : cust.proceedWithSmartchoice;
      cust.proceedWithSubscriptionExpiry = cust.proceedWithSubscriptionExpiry ? this.terminationformDetails.get('proceedWithSubscriptionExpiry').value : cust.proceedWithSubscriptionExpiry;
      cust.proceedWithCancelCustomer = cust.proceedWithCancelCustomer ? this.terminationformDetails.get('proceedWithCancelCustomer').value : cust.proceedWithCancelCustomer
      cust.proceedWithEquitable = cust.proceedWithEquitable ? this.terminationformDetails.get('proceedWithEquitable').value : cust.proceedWithEquitable
      cust.refundAmount = cust.refundAmount ? this.terminationformDetails.get('refundAmount').value : cust.refundAmount
    })


    let data = {
      'data': this.terminateAllDetails,
      'bulkPlanEmployeeIds': this.bulkPlanEmployeeIds,
      'reason': this.terminationformDetails.get('reason').value ?? " ",
      'selectedEmployeeIds': selectedEmployeeIds
    };

    console.log(data)
    this.logger.log(this.terminationform.value)
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    let terminateDate = this.datePipe.transform(this.terminationform.value.terminationDate, 'yyyy-MM-dd') || ''

    let queryParams = new HttpParams();
    queryParams = queryParams.append("terminationDate", terminateDate);
    // this.http
    //   .get(environment.apiUrl + terminate, {
    //     headers: {
    //       Authorization: 'Bearer ' + accessToken,
    //       'Content-Type': 'application/json',
    //     },
    //     params: queryParams
    //   })
    var terminate = '/api/ap/admin/corporate/' + this.memberid + '/terminate';
    var headers = {
      Authorization: 'Bearer ' + accessToken,
      'Content-Type': 'application/json',
    };

    this.http.post(environment.apiUrl + terminate, data, { headers: headers, params: queryParams })
      .subscribe(async (responce: any) => {
        if (responce.status == '200') {
          $('#showTerminateMemberDetailsCorpoarteList').modal('hide');
          $('#showTerminateMemberDetailsCorpoarte').modal('hide');

          var getClients = 'api/ap/admin/corporate/details/false';

          // await postServiceWorkerMessage(WorkerMessageType.Delete, [
          //   environment.apiUrl + getClients
          // ]);

          Swal.fire({ title: "Info", html: responce.message }).then((res) => {
            if (res.isConfirmed) {

              // this.store.dispatch(loadCorporateData())

              this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => { })

              this.clientList = this.clientList.map(member =>
                member.id == this.memberid ? { ...member, status: 'Cancelled' } : member
              );
              // this.members=[]
              this.store.dispatch(loadCorporateDataSuccess({ corporateData: this.clientList }))

              this.getclientList();
              // this.getServiceWorkerDetails()
              // $("#DataTables_Table_0").dataTable().fnDestroy();
              this.dtTrigger.next(null);
            }
          });

          $('#showTerminateMemberDetailsCorpoarte').modal('hide');

        } else {
          Swal.fire({ title: "info", text: responce.data.message });
        }

      }, (error) => {
        Swal.fire({ title: "Error", text: error.message || error.data.message });
      })

  }
  closeTerminatePopup(id: any) {
    $(`#${id}`).modal("hide");
    this.terminationform.reset();
  }


  onClick(i) {
    console.log(i)
  }
  submittermination() {
    this.terminateMemberDetails = []
    if (this.terminationform.invalid) {
      this.logger.log(this.terminationform.invalid)
      this.toastrService.error(`Minimium Date : ${moment(this.minDate).format('MM-DD-YYYY')} \n Note: ${this.note}`);
      this.terminationform.markAllAsTouched()
      return
    }
    this.logger.log(this.terminationform.value)
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');

    let data = {
      "reason": this.terminationform.value.reason,
      "memberStatus": this.terminationform.value.memberstatus,
      "terminationDate": this.datePipe.transform(
        this.terminationform.value.terminationDate,
        'yyyy-MM-dd'
      ) || ''
    }
    let terminateDate = this.datePipe.transform(this.terminationform.value.terminationDate, 'yyyy-MM-dd') || ''

    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var terminate = '/api/ap/member/' + this.memberid + '/configureMemberTermination';
    // /member/{memberId}/configureMemberTermination
    let queryParams = new HttpParams();
    queryParams = queryParams.append("terminationDate", terminateDate);
    this.http
      .get(environment.apiUrl + terminate, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
        params: queryParams
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            $("#terminateConfirmDateModal").modal('hide');
            $('#showTerminateMemberDetails').modal('show');
            let terminationGSDetails = []

            let allMemberDetails = response.data;
            this.terminateMemberDetails = response.data.filter((p: any) => !p.isParentAccount);
            this.terminateParentDetails = response.data.find((p: any) => p.isParentAccount);
            this.terminateAllDetails = response.data;

            this.bulkPlanEmployeeIds = response.bulkPlanEmployeeIds;


            this.terminateReasonsApplicable = this.terminateParentDetails?.terminateReasonsApplicable;
            this.servicDetails = this.terminateParentDetails?.serviceDetails;
            this.terminateReasonsWithKeys = response.data.terminateReasonsWithKeys;
            this.logger.log('terminateReasonsWithKeys', this.terminateReasonsWithKeys);
            this.staxbillDetails = this.terminateParentDetails?.staxbillDetails;

            this.terminationsProvisioning = this.terminateParentDetails?.terminationsProvisioning[0]
            let proceedWithEquitable = this.terminationsProvisioning?.proceedWithEquitable;
            let proceedWithGreenshield = this.terminationsProvisioning?.proceedWithGreenshield;
            let proceedWithRefund = this.terminateParentDetails?.proceedWithRefund;
            let proceedWithSmartchoice = this.terminationsProvisioning?.proceedWithSmartchoice;
            let proceedWithSubscriptionExpiry = this.terminateParentDetails?.proceedWithSubscriptionExpiry;
            let proceedWithCancelCustomer = this.terminateParentDetails?.proceedWithCancelCustomer;
            let refundAmount = this.terminateParentDetails?.staxbillDetails.refundAmount == 'NA' ? "N/A" : this.terminateParentDetails?.staxbillDetails.refundAmount;


            this.terminationformDetails.get('proceedWithEquitable').setValue(proceedWithEquitable);
            this.terminationformDetails.get('proceedWithGreenshield').setValue(proceedWithGreenshield);
            this.terminationformDetails.get('proceedWithRefund').setValue(proceedWithRefund);
            this.terminationformDetails.get('proceedWithSmartchoice').setValue(proceedWithSmartchoice);
            this.terminationformDetails.get('proceedWithSubscriptionExpiry').setValue(proceedWithSubscriptionExpiry);
            this.terminationformDetails.get('proceedWithCancelCustomer').setValue(proceedWithCancelCustomer);
            this.terminationformDetails.get('refundAmount').setValue(refundAmount);

            for (let control of Object.keys(this.terminationformDetails.controls)) {
              this.terminationformDetails.get(control).updateValueAndValidity();
            }
            // Swal.fire({ title: 'Info', text: response.message })
          } else {
            Swal.fire({ title: 'Error', text: response.message })
          }
        }, (error) => {
          if (error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Proceed',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
        }
      );
  }
  submitterminationCorporate() {
    this.terminateMemberDetails = []
    if (this.terminationform.invalid) {
      this.logger.log(this.terminationform.invalid)
      this.toastrService.error(`Minimium Date : ${moment(this.minDate).format('MM-DD-YYYY')} \n Note: ${this.note}`);
      this.terminationform.markAllAsTouched()
      return
    }


    this.allBrokers.forEach(element => {
      if (element.name.trim().toLowerCase() === this.brokerprofiles.parentName.trim().toLowerCase()) {
        this.advisorBasedBrokers.push(element)
      }

    });
    // Swal.fire({
    //   title:'Info',
    //   text:'Transfer members to gig Profiles?',
    //   confirmButtonText:'Yes',
    //   showDenyButton:true,
    //   denyButtonText:'No'
    // }).then(result=>{
    //   if(result.isConfirmed){
    //     console.log('confirmed')
    //   }else{
    //     console.log('rejected')
    //   }
    // })

    this.logger.log(this.terminationform.value)
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');

    let data = {
      "reason": this.terminationform.value.reason,
      "memberStatus": this.terminationform.value.memberstatus,
      "terminationDate": this.datePipe.transform(
        this.terminationform.value.terminationDate,
        'yyyy-MM-dd'
      ) || ''
    }
    let terminateDate = this.datePipe.transform(this.terminationform.value.terminationDate, 'yyyy-MM-dd') || ''

    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var terminate = '/api/ap/admin/corporate/' + this.memberid + '/terminateConfiguration';
    // /member/{memberId}/configureMemberTermination
    let queryParams = new HttpParams();
    queryParams = queryParams.append("terminationDate", terminateDate);
    this.http
      .get(environment.apiUrl + terminate, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
        params: queryParams
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {


            $("#terminateConfirmDateModalCorporate").modal('hide');
            // $('#showTerminateMemberDetailsCorpoarte').modal('show');



            let terminationGSDetails = []
            let allMemberDetails = response.data;
            this.terminateMemberDetails = response.data.filter((p: any) => !p.isParentAccount);
            this.terminateParentDetails = response.data.find((p: any) => p.isParentAccount);
            this.terminateAllDetails = response.data;

            this.bulkPlanEmployeeIds = response.bulkPlanEmployeeIds;
            if (!this.showCorporateEmployees) {
              this.submitterminationEndCorporate()
            }
            else {
              $('#showTerminateMemberDetailsCorpoarte').modal('show');

              this.terminateMemberDetails.forEach(element => {
                // this.getForms(element.brokerId)
                this.onBrokerChange(element.brokerId, element)

              });
            }

            this.dtTrigger5.next(null);


            // this.terminateMemberDetails.forEach(element => {
            //   // this.getForms(element.brokerId)
            //   this.onBrokerChange(element.brokerId, element)

            // });

            this.terminateReasonsApplicable = this.terminateParentDetails?.terminateReasonsApplicable;
            this.servicDetails = this.terminateParentDetails?.serviceDetails;
            this.terminateReasonsWithKeys = response.data[0].terminateReasonsWithKeys;
            this.logger.log('terminateReasonsWithKeys', this.terminateReasonsWithKeys);
            this.staxbillDetails = this.terminateParentDetails?.staxbillDetails;

            this.terminationsProvisioning = this.terminateParentDetails?.terminationsProvisioning[0]
            let proceedWithEquitable = this.terminationsProvisioning?.proceedWithEquitable;
            let proceedWithGreenshield = this.terminationsProvisioning?.proceedWithGreenshield;
            let proceedWithRefund = this.terminateParentDetails?.proceedWithRefund;
            let proceedWithSmartchoice = this.terminationsProvisioning?.proceedWithSmartchoice;
            let proceedWithSubscriptionExpiry = this.terminateParentDetails?.proceedWithSubscriptionExpiry;
            let proceedWithCancelCustomer = this.terminateParentDetails?.proceedWithCancelCustomer;
            let refundAmount = this.terminateParentDetails?.staxbillDetails.refundAmount == 'NA' ? "N/A" : this.terminateParentDetails?.staxbillDetails.refundAmount;


            this.terminationformDetails.get('proceedWithEquitable').setValue(proceedWithEquitable);
            this.terminationformDetails.get('proceedWithGreenshield').setValue(proceedWithGreenshield);
            this.terminationformDetails.get('proceedWithRefund').setValue(proceedWithRefund);
            this.terminationformDetails.get('proceedWithSmartchoice').setValue(proceedWithSmartchoice);
            this.terminationformDetails.get('proceedWithSubscriptionExpiry').setValue(proceedWithSubscriptionExpiry);
            this.terminationformDetails.get('proceedWithCancelCustomer').setValue(proceedWithCancelCustomer);
            this.terminationformDetails.get('refundAmount').setValue(refundAmount);


            for (let control of Object.keys(this.terminationformDetails.controls)) {
              this.terminationformDetails.get(control).updateValueAndValidity();
            }




            // Swal.fire({ title: 'Info', text: response.message })
          } else {
            Swal.fire({ title: 'Error', text: response.message })
          }
        }, (error) => {
          if (error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Proceed',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
        }
      );
  }

  closeModelPopup(id: any) {
    this.logger.log(id)
    $('#' + id).modal('hide');
  }

  // openpreviousModel() {

  //   $("#showTerminateMemberDetailsCorpoarteList").modal('hide')
  //   $("#showTerminateMemberDetailsCorpoarte").modal('show')
  // }

  // terminatemember(client: any, index: number) {


  //   this.emplomentName = client.name

  //   this.memberid = client.id

  //   Swal.fire({
  //     title: 'Info',
  //     text: 'Are you sure you want to Terminate?',
  //     showCancelButton: true,
  //     confirmButtonColor: '#10104d',
  //     cancelButtonColor: '#10104d',
  //     confirmButtonText: 'Yes',
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       $("#terminatemember").modal('show')
  //     }
  //   });

  // }
  // submittermination() {

  //   this.logger.log(this.terminationform.value)


  //   let data = {
  //     "reason": this.terminationform.value.reason,
  //     "memberStatus": this.terminationform.value.memberstatus,
  //     "terminationDate": this.datePipe.transform(
  //       this.terminationform.value.terminationDate,
  //       'MM-dd-yyyy'
  //     ) || ''
  //   }

  //   var corporateId = sessionStorage.getItem('corporateId');
  //   var accessToken = sessionStorage.getItem('accessToken');
  //   var terminate = '/api/ap/member/' + this.memberid + '/terminate';
  //   this.http
  //     .post(environment.apiUrl + terminate, data, {
  //       headers: {
  //         Authorization: 'Bearer ' + accessToken,
  //         'Content-Type': 'application/json',
  //       },
  //     })
  //     .subscribe(
  //       (response: any) => {
  //         if (response['status'] == 200 || response['statusCode'] == 200) {
  //           $("#terminatemember").modal('hide')
  //           this.getclientList()

  //         } else {
  //           Swal.fire({ title: 'Error', text: response.message })
  //         }
  //       },
  //       (error) => {
  //         if (
  //           error.status == 400 ||
  //           error.status == 401 ||
  //           error.status == 402 ||
  //           error.status == 403
  //         ) {
  //           Swal.fire({
  //             title: 'Error',
  //             text: error.error.error.message,
  //             showDenyButton: false,
  //             showCancelButton: true,
  //             confirmButtonText: 'Proceed',
  //           }).then((result) => {
  //             /* Read more about isConfirmed, isDenied below */
  //             if (result.isConfirmed) {
  //               sessionStorage.clear();
  //               this.router.navigate(['/login']);
  //             }
  //             else {
  //               sessionStorage.clear();
  //               this.router.navigate(['/login']);
  //             }
  //           });
  //         } else {
  //           Swal.fire({ title: 'Error', text: error.error.error.message });
  //         }
  //       }
  //     );
  // }
  viewsubBrokerList(brokerlist) {

    $('#subGroupList-modal').modal('show');
    this.logger.log(brokerlist)
    this.customerslist = brokerlist
    // $("#DataTables_Table_1").dataTable().OnDestroy()
    $("#DataTables_Table_1").dataTable().fnDestroy();

  }


  @ViewChild(ConfirmationDialogComponent) confirmationDialog: ConfirmationDialogComponent;




  sendInvitationEmail(details: any, index: any) {
    var accessToken = sessionStorage.getItem('accessToken');
    var GetBrokers = `/api/ap/member/${details.uId}/inviteMail`;
    // https://testadminapi.groupbenefitz.aitestpro.com/api/ap/member/20271/inviteMail
    //https://testadminapi.groupbenefitz.aitestpro.com/api/ap/admin/corporate/1660/invitation
    this.http.get(environment.apiUrl + GetBrokers, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {

      if (response['status'] == 200 || response['statusCode'] == 200) {
        Swal.fire({ title: "Info", text: response.message })
      } else {
        Swal.fire({ title: 'Error', text: response.message })
      }


    }), (error) => {
      Swal.fire({ title: 'Error', text: error.error.error.message });
    }

  }

  // invitationCorporate(details: any, index: any) {

  //   if(details.published==false){
  //     Swal.fire({
  //       title: 'Info',
  //       text: details.name + " is inactive status, still do you want to continue?",
  //       showDenyButton: false,
  //       showCancelButton: true,
  //       confirmButtonText: 'Proceed',
  //     }).then((result) => {
  //       /* Read more about isConfirmed, isDenied below */
  //       if (result.isConfirmed) {
  //         this.isCorporate = true
  //         this.message = this.lang.Send_portal_access_link_to + `${details.name}`

  //         const accessToken = sessionStorage.getItem('accessToken');
  //         const getGroupContacts = `/api/ap/admin/corporate/${details.id}/groupAdmins`;
  //         this.loader = true
  //         this.http.get(environment.apiUrl + getGroupContacts, {
  //           headers: {
  //             Authorization: 'Bearer ' + accessToken,
  //             'Content-Type': 'application/json',
  //           }
  //         }).subscribe((response: any) => {
  //           this.loader = false
  //           if (response['status'] == 200 || response['statusCode'] == 200) {
  //             const checkboxes = response.data
  //             this.checkboxesForMail = checkboxes.map((c: any, i: number) => {
  //               const obj = {
  //                 label: `${c.roleNameDisplay == "Others" ? c.roleName.charAt(0).toUpperCase() + c.roleName.slice(1).toLowerCase() :  c.roleNameDisplay.charAt(0).toUpperCase() + c.roleNameDisplay.slice(1).toLowerCase()} ${c.firstName} ${c.lastName} {${c.email}}`,
  //                 checked: false,
  //                 id: c.groupAdminId
  //               }
  //               return obj
  //             }
  //             )
  //             this.inviteGroupContacts(details.id)
  //           } else {
  //             Swal.fire({ title: 'Error', text: response.message })
  //           }
  //         }), (error) => {
  //           this.loader = false
  //           Swal.fire({ title: 'Error', text: error.error.error.message });
  //         }
  //       }
  //       else {

  //       }
  //     });
  //   }




  // }

  invitationCorporate(details: any, index: any) {
    this.isCorporate = true
    this.message = this.lang.Send_portal_access_link_to + `${details.name}`

    const accessToken = sessionStorage.getItem('accessToken');
    const getGroupContacts = `/api/ap/admin/corporate/${details.id}/groupAdmins`;
    this.loader = true
    this.http.get(environment.apiUrl + getGroupContacts, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      this.loader = false
      if (response['status'] == 200 || response['statusCode'] == 200) {
        const checkboxes = response?.data
        this.checkboxesForMail = checkboxes.map((c: any, i: number) => {
          const obj = {
            label: `${c.roleNameDisplay == "Others" ? c.roleName?.charAt(0).toUpperCase() + c.roleName?.slice(1).toLowerCase() : c.roleNameDisplay?.charAt(0).toUpperCase() + c.roleNameDisplay?.slice(1).toLowerCase()} ${c.firstName} ${c.lastName} {${c.email}}`,
            checked: false,
            id: c.groupAdminId
          }
          if (obj.label.includes('NaN')) {
            let role = c?.role?.split('_')[1];
            let roleFormatted = role?.charAt(0).toUpperCase() + role?.slice(1).toLowerCase();
            obj.label = obj.label.replace('NaN', roleFormatted);
          }
          return obj
        }
        )
        console.log('checkboxesForMail',this.checkboxesForMail)
        this.invitationId = details.id;
        this.inviteGroupContacts(details.id)
      } else {
        Swal.fire({ title: 'Error', text: response.message })
      }
    }), (error) => {
      this.loader = false
      Swal.fire({ title: 'Error', text: error.error.error.message });
    }

    this.logger.log("checboxes", this.checkboxesForMail)

  }

  invitationbroker(details: any, index: any) {
    this.isCorporate = false

    this.message = this.lang.Send_access_link_to_Member_Portal_for + `${details.firstName} ${details.lastName} ?`

    $('#confirmationModal').modal('show');

    if (!this.isSubscribed) {
      this.confirmationDialog.confirmed.subscribe(obj => {
        this.isSubscribed = true;
        if (obj.confirmed) {
          this.sendInvitationEmail(details, index);
        }
        $('#confirmationModal').modal('hide');
      });
    }
  }


  inviteGroupContacts(id: number) {
    if(this.sendInviteClicked == false){
      this.sendInviteClicked = true;
    }else{
      this.sendInviteClicked = false;
      return;
    }

    $('#confirmationModal').modal('show');
    if (!this.isSubscribed) {
      this.confirmationDialog.confirmed.subscribe(obj => {
        this.isSubscribed = true;
        if (obj.confirmed) {
          this.logger.log(obj)
          const brokerAdminIds = obj.selectedCheckboxes.map((o, i) => (o.id))
          if (obj.confirmed) {
            const accessToken = sessionStorage.getItem('accessToken');
            const GetBrokers = `/api/ap/admin/corporate/${this.invitationId}/invitation`;
            this.http.post(environment.apiUrl + GetBrokers, { brokerAdminIds }, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              }
            }).subscribe((response: any) => {
              this.sendInviteClicked = false;
              if (response['status'] == 200 || response['statusCode'] == 200) {
                Swal.fire({ title: "Info", text: response.message })
                setTimeout(() => {
                  this.dtTrigger.next(null);
                }, 100);
              } else {
                Swal.fire({ title: 'Error', text: response.message })
                setTimeout(() => {
                  this.dtTrigger.next(null);
                }, 100);
              }


            }), (error) => {
              this.sendInviteClicked = false;
              Swal.fire({ title: 'Error', text: error.error.error.message });
              setTimeout(() => {
                this.dtTrigger.next(null);
              }, 100);
            }
          }
        }
        $('#confirmationModal').modal('hide');
      });

    }
  }

  public viewBrokerDetails(broker: any, index: number) {
    const showTiles = broker.adminApproved;

    console.log(broker)
    this.router.navigate(['/manageCorporates/' + broker.id + '/view']);

    // if (broker.adminApproved) {
    //  this.router.navigate(['/manageCorporates/' + broker.id + '/view']);
    // } else {
    //   Swal.fire({
    //     title: 'Info',
    //     text: '',
    //     showDenyButton: false,
    //     showCancelButton: true,
    //     confirmButtonText: 'View Dashboard',
    //     cancelButtonText:'Edit'
    //   }).then((result) => {
    //     /* Read more about isConfirmed, isDenied below */
    //     if (result.isConfirmed) {
    //       this.router.navigate(['/manageCorporates/' + broker.id + '/view']);

    //     }
    //     else {
    //       alert("1")

    //     }
    //   });
    // }
    // this.router.navigate(['/manageCorporates/' + broker.id + '/view']);

    // if (showTiles) {
    //   this.router.navigate(['/manageCorporates/' + broker.id + '/view']);
    // } else {
    //   this.router.navigate(['/manageCorporates/edit-corporate/' + broker.id]);
    // }


  }
  public viewBrokerDetailspopup() {

    $("#showmemberlist").modal('hide')
    $("#showGroupPlansList").modal('hide')

    this.router.navigate(['/manageCorporates/' + this.empprofilesid + '/view']);

    // if (showTiles) {
    //   this.router.navigate(['/manageCorporates/' + broker.id + '/view']);
    // } else {
    //   this.router.navigate(['/manageCorporates/edit-corporate/' + broker.id]);
    // }


  }
  public viewMemberDetails(member: any, index: number) {

    $("#showmemberlist").modal('hide')
    sessionStorage.setItem("customerId", member.uId)
    this.SharedService.setUserName(member.firstName + " " + member.lastName)

    this.router.navigate(['/manageMembers/employee/' + member.uId + '/details']);


  }
  // public viewMemberDetails(member:any,index:number){

  //   $("#showmemberlist").modal('hide')
  //     sessionStorage.setItem("customerId",member.uId)
  //     this.router.navigate(['/employee/'+member.uId+'/details']);

  //   }
  public viewBrokerCustomers(broker: any, index: number) {
    $('#subGroupList-modal').modal('hide');
    this.router.navigate(['/advsiors/' + broker.id + '/customers']);

    // /broker/{brokerId}/details

  }




  async ShowDetails(data: any, id: any) {

    this.empprofilesid = id
    this.employeelist = []
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    // var GetBrokers = `/api/ap/broker/${id}/details`;
    var GetEmployees = `/api/ap/admin/corporate/${id}/nonbulk/employees`

    // await postServiceWorkerMessage(WorkerMessageType.Delete, [
    //               environment.apiUrl + GetEmployees
    //             ]);

    this.http.get(environment.apiUrl + GetEmployees, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response['status'] == 200 || response['statusCode'] == 200) {
        this.logger.log("responce details", JSON.stringify(response));

        // this.employeelist = response.data.employees
        $("#showmemberlist").modal('show')

        this.employeelist = response.data.nonBulkEmployee.sort((a, b) => {

          const order = { Active: 1, Incomplete: 2, Hold: 3, Cancelled: 4, Draft: 5, Suspended: 6 };

          if (order[a.status] !== order[b.status]) {
            return order[a.status] - order[b.status];
          }

          return a.firstName.trim().localeCompare(b.firstName.trim());
        });

        this.corporateCustomerAccount = response.data.corporateCustomerAccount

        this.corporateCompany = data.name

        this.dtTrigger1.next(null);
        // $('#showmemberlist').show();
      } else {
        Swal.fire({ title: 'Error', text: response.message })
      }
    }), (error) => {
      Swal.fire({ title: 'Error', text: error.error.error.message });
    }

  }

  closelist() {
    this.employeelist = [];
    $("#showmemberlist").modal('hide')
    $("#DataTables_Table_1").dataTable().fnDestroy();


  }
  closelistCorporate() {
    this.terminateMemberDetails = [];
    $("#showTerminateMemberDetailsCorpoarte").modal('hide')
    $("#DataTables_Table_4").dataTable().fnDestroy();
  }

  ShowGroupPlansDetails(data: any, id: any) {
    this.logger.log("bulk count", data.bulkEmployeeCount)

    this.empprofilesid = id

    var accessToken = sessionStorage.getItem('accessToken');
    const getGroupPlansList = `/api/ap/admin/corporate/${id}/bulk/employees`


    this.http.get(environment.apiUrl + getGroupPlansList, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response['status'] == 200 || response['statusCode'] == 200) {
        this.logger.log("responce grp plans", JSON.stringify(response));

        $("#DataTables_Table_2").dataTable().fnDestroy();
        $("#DataTables_Table_3").dataTable().fnDestroy();
        $("#DataTables_Table_4").dataTable().fnDestroy();


        this.groupPlansList = response.data.bulkEmployee
        this.corporateCustomerAccount = response.data.corporateCustomerAccount
        this.corporateBulkPlan = response.data.corporateBulkPlan.sort((a, b) => {

          const order = { Active: 1, Incomplete: 2, Hold: 3, Cancelled: 4, Draft: 5, Suspended: 6 };

          if (order[a.status] !== order[b.status]) {
            return order[a.status] - order[b.status];
          }

          return a.planLevel?.trim().localeCompare(b.PlanLevel?.trim());
        })
        this.logger.log({ bulkplans: this.corporateBulkPlan })

        this.corporateCompany1 = data.name
        this.dtTrigger4.next(null)
        this.dtTrigger3.next(null)
        $('#showGroupPlansList').show();


      } else {
        Swal.fire({ title: 'Error', text: response.message })
      }
    }), (error) => {
      Swal.fire({ title: 'Error', text: error.error.error.message });
    }

  }


  public addClientDetails() {
    this.router.navigate(['/manageCorporates/addCorporate']);
  }

  addEmployee(client) {
    //  alert(compName)

    console.log(client)
    if (client.published == false) {
      Swal.fire({
        title: 'Info',
        text: client.name + " is inactive status, still do you want to continue?",
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Proceed',
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          sessionStorage.setItem('corpId', client.id);
          sessionStorage.setItem("compName", client.name);
          sessionStorage.setItem("compFormId", client.formId);

          this.router.navigate(['/manageCorporates/addEmployee']);
        }
        else {

        }
      });
    }
    else {
      sessionStorage.setItem('corpId', client.id);
      sessionStorage.setItem("compName", client.name);
      sessionStorage.setItem("compFormId", client.formId);

      this.router.navigate(['/manageCorporates/addEmployee']);
    }



    // alert('1212')
  }
  scrollTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  // public getclientList() {

  //   var corporateId = sessionStorage.getItem('corporateId');
  //   var accessToken = sessionStorage.getItem('accessToken');
  //   // var getClients = '/api/ap/admin/corporate/details/false';
  //   const role = sessionStorage.getItem('role')
  //   let getClients = ''
  //   if (role == 'ADMINISTRATOR') {
  //     // getClients = 'http://[::1]:3002/api/ap/global/adminCorporates';
  //     getClients = '/api/ap/global/adminCorporates';
  //   } else {
  //     getClients = '/api/ap/admin/corporate/details/false';
  //   }
  //   this.loader = true;
  //   this.clientList = []

  //   this.http
  //     .get(environment.apiUrl + getClients, {
  //       // .get( getClients, {
  //       headers: {
  //         Authorization: 'Bearer ' + accessToken,
  //         'Content-Type': 'application/json',
  //       },
  //     })
  //     .subscribe(
  //       (response: any) => {
  //         if (response['status'] == 200 || response['statusCode'] == 200) {
  //           this.loader = false;
  //           // this.clientList = (response as any).data;


  //           if (role == 'ADMINISTRATOR') {
  //             this.clientList = decompress(response.data)
  //             // console.log(this.clientList)
  //           } else {
  //             this.clientList = response.data.map(res => {
  //               return {
  //                 ...res,
  //                 formsLength: res.forms?.length || 0
  //               }
  //             })
  //           }
  //           this.filterStatus = [];
  //           this.clientList.map((member) => {
  //             if (!this.filterStatus.includes(member.status))
  //               this.filterStatus.push(member.status);
  //           });
  //           this.allClientList = this.clientList;
  //           this.clientList.sort((a, b) => {

  //             const order = { true: 1, false: 2, cancelled: 3 };

  //             if (order[a.status] !== order[b.status]) {
  //               return order[a.status] - order[b.status];
  //             }
  //             // const result = a.name.localeCompare(b.name);
  //             // return result !== 0 ? result : a.lastName.localeCompare(b.lastName);
  //             return a.name.trim().localeCompare(b.name.trim());
  //           });
  //           // this.dtTrigger.next(null);
  //           this.restLoader = false
  //           setTimeout(() => {
  //             this.showfilter = true;
  //           }, 1000);
  //           // this.http.get(environment.apiUrl+'/api/ap/global/set-adminCorporates').subscribe((newResponse) => {})
  //         } else {
  //           this.loader = false
  //           Swal.fire({ title: 'Error', text: response.message })
  //         }
  //       },
  //       (error) => {
  //         this.loader = false;
  //         if (
  //           error.status == 400 ||
  //           error.status == 401 ||
  //           error.status == 402 ||
  //           error.status == 403
  //         ) {
  //           Swal.fire({
  //             title: 'Error',
  //             text: error.error.error.message,
  //             showDenyButton: false,
  //             showCancelButton: false,
  //             confirmButtonText: 'Proceed',
  //           }).then((result) => {
  //             /* Read more about isConfirmed, isDenied below */
  //             if (result.isConfirmed) {
  //               sessionStorage.clear();
  //               this.router.navigate(['/login']);
  //             }
  //             else {
  //               sessionStorage.clear();
  //               this.router.navigate(['/login']);
  //             }
  //           });
  //         } else {
  //           // Swal.fire(error.error.error.message)
  //           Swal.fire({ title: 'Error', text: error.error.error.message });
  //         }
  //         // this.toastrService.error("Invalid Credentials", 'Error!');
  //       }
  //     );
  // }

  public getclientList() {
    this.store.dispatch(loadCorporateData());
    this.corporateData$ = this.store.select(state => state.corporateData).pipe(
      // startWith([]),
      // takeUntil(this.destroy$)
    );
    this.corporateData$.subscribe(data => {
      if (data) {
        console.log(data)
        if ((data?.corporateData == undefined || Object.keys(data.corporateData).length <= 0) && data?.loading == true) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        if (this.clientList.length > 0 && data?.loading == false) {
          this.dtTrigger.next(null);
          return;
        }
        this.sortColumn = 'name';
        this.sortOrder = 'ASC';
        this.loader = false;

        const role = sessionStorage.getItem('role');
        if (role == 'ADMINISTRATOR') {
          // this.clientList = decompress(data.corporateData)
          this.clientList = data.corporateData
        } else {
          this.clientList = data.corporateData.map(res => {
            return {
              ...res,
              formsLength: res.forms?.length || 0
            }
          })
        }
        this.filterStatus = [];
        this.clientList?.map((member) => {
          if (!this.filterStatus.includes(member.status))
            this.filterStatus.push(member.status);
          if (!member.published || member.published == undefined || member.published == null) {
            return { ...member, published: false }
          } else {
            return { ...member }
          }
        });
        setTimeout(() => {
          this.allClientList = this.clientList;
          const sortedList = [...this.clientList].filter((client: any) => client.name!=null && client.name!=undefined).sort((a, b) => {
            const order = { true: 1, false: 2, cancelled: 3 };
            if (order[a.status] !== order[b.status]) {
              return order[a.status] - order[b.status];
            }
            return a.name.trim().localeCompare(b.name.trim());
          });
          this.clientList = sortedList;
          this.restLoader = false;
          setTimeout(() => {
            this.dtTrigger.next(null);
          }, 0);
        }, 0)
      } else {
        console.error('Observable returned undefined');
      }
    })
  }

  get filteredAndPaginatedCorporates() {
    const filteredCorporates = this.clientList.filter(member => {
      return Object.values(member).some(value =>
        String(value).toLowerCase().includes(this.filterValue.toLowerCase())
      );
    });

    // Sort the filtered corporates based on the current sort column and order
    if (this.sortColumn) {
      filteredCorporates.sort((a, b) => {
        let valueA = a[this.sortColumn] != undefined && a[this.sortColumn] != null ? a[this.sortColumn] : '';
        let valueB = b[this.sortColumn] != undefined && b[this.sortColumn] != null ? b[this.sortColumn] : '';

        // If the value is a boolean, convert to 1 or 0 for sorting
        if (typeof valueA == 'boolean') {
          valueA = valueA ? 1 : 0;
        }
        if (typeof valueB == 'boolean') {
          valueB = valueB ? 1 : 0;
        }

        // Trim and normalize strings (to lower case) for comparison
        if (typeof valueA == 'string') {
          valueA = valueA.trim().toLowerCase();
        }
        if (typeof valueB == 'string') {
          valueB = valueB.trim().toLowerCase();
        }

        // Handle dates
        if (typeof valueA == 'string' && Date.parse(valueA)) {
          valueA = new Date(valueA);
        }
        if (typeof valueB == 'string' && Date.parse(valueB)) {
          valueB = new Date(valueB);
        }

        // Compare strings alphabetically
        if (typeof valueA == 'string' && typeof valueB == 'string') {
          // if (valueA < valueB) {
          //   return this.sortOrder === 'ASC' ? -1 : 1;
          // }
          // if (valueA > valueB) {
          //   return this.sortOrder === 'ASC' ? 1 : -1;
          // }
          valueA = this.normalizeString(valueA);
          valueB = this.normalizeString(valueB);
          if (this.sortOrder == 'ASC') {
            return valueA.localeCompare(valueB);
          } else {
            return valueB.localeCompare(valueA);
          }
        }

        // Compare numbers
        if (typeof valueA == 'number' && typeof valueB == 'number') {
          if (valueA < valueB) {
            return this.sortOrder === 'ASC' ? -1 : 1;
          }
          if (valueA > valueB) {
            return this.sortOrder === 'ASC' ? 1 : -1;
          }
        }

        // Compare dates (after parsing string to Date)
        if (valueA instanceof Date && valueB instanceof Date) {
          return this.sortOrder === 'ASC' ? valueA.getTime() - valueB.getTime() : valueB.getTime() - valueA.getTime();
        }

        return 0;
      });
    }

    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return filteredCorporates.slice(startIndex, startIndex + this.itemsPerPage);
  }

  sortTable(column: string): void {
    console.log('Sorting by column:', column);

    // Toggle the sort order if the same column is clicked
    if (this.sortColumn == column) {
      this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
    } else {
      // Default to ascending order if a new column is clicked
      this.sortColumn = column;
      this.sortOrder = 'ASC';
    }
  }

  normalizeString(value: string): string {
    return value.replace(/[^\w\s]/g, '');
  }

  totalPages() {
    // return Math.ceil(this.members.length / this.itemsPerPage);
    const filteredMembers = this.clientList.filter(member => {
      return Object.values(member).some(value =>
        String(value).toLowerCase().includes(this.filterValue.toLowerCase())
      );
    });
    return Math.ceil(filteredMembers.length / this.itemsPerPage);
  }

  nextPage() {
    if (this.currentPage < this.totalPages()) {
      this.currentPage++;
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  public deletebrokerDetails(broker: any, index: any) {

    this.logger.log(broker)
    // this.logger.log(index)
    var accessToken = sessionStorage.getItem('accessToken');
    var deleteBroker = '/api/ap/broker/' + broker.id + ''


    Swal.fire({
      title: 'Alert',
      text: 'Are you sure you want to delete this ' + broker.brokerType + '?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Proceed',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        this.http
          .delete(environment.apiUrl + deleteBroker, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            async (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {
                // this.dtTrigger.next("");
                // window.location.reload()
                // this.getBrokerList()

                var getClients = 'api/ap/admin/corporate/details/false';

                // await postServiceWorkerMessage(WorkerMessageType.Delete, [
                //   environment.apiUrl + getClients
                // ]);
                this.getclientList()
                // this.getServiceWorkerDetails()
              } else {
                Swal.fire({ title: 'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: 'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: 'Proceed',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: 'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
      }
    })

  }

  public memberStatus(member: any, event: any, index: number) {
    $("#DataTables_Table_0").dataTable().fnDestroy();
    // $("#DataTables_Table_0").dataTable().fnDestroy();
    var accessToken = sessionStorage.getItem('accessToken');
    var brokerStatus = '/api/ap/customer/' + member.uId + '/status/' + event

    let obj = {}
    Swal.fire({
      title: 'Alert',
      text: 'Are you sure you want to change ' + member.firstName + ' status?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Proceed',
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        // $("#DataTables_Table_0").dataTable().fnDestroy();

        this.http
          .put(environment.apiUrl + brokerStatus, obj, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(

            async (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {

                var getClients = 'api/ap/admin/corporate/details/false';

                // await postServiceWorkerMessage(WorkerMessageType.Delete, [
                //   environment.apiUrl + getClients
                // ]);
                this.getclientList();

                // this.getServiceWorkerDetails()
                // this.logger.log(this.clientList);
                // window.location.reload()
              } else {
                Swal.fire({ title: 'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: 'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: 'Proceed',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: 'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }

          );
      }
      else {
        var getClients = 'api/ap/admin/corporate/details/false';

        // await postServiceWorkerMessage(WorkerMessageType.Delete, [
        //   environment.apiUrl + getClients
        // ]);
        this.getclientList();
        // this.getServiceWorkerDetails()
      }
    })

  }
  toggleAccordion(index: number) {
    console.log(index)
    console.log(this)
    this.data1[index].isActive = !this.data1[index].isActive;
  }


  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
    this.dtTrigger1.unsubscribe();
    this.dtTrigger2.unsubscribe();
    this.dtTrigger3.unsubscribe();
    this.dtTrigger4.unsubscribe();
    this.dtTrigger5.unsubscribe();
    // this.http.get(environment.apiUrl+'/api/ap/global/set-adminCorporates').subscribe(()=>{})
    // this.store.dispatch(loadCorporateDataSuccess({corporateData:[]}));
    // this.store.dispatch(loadCorporateData());

    console.log('CorporateGateway', 'Destroyed');
    this.socketCorporateService.disconnect();
    if (this.socketSubscription) {
      this.socketSubscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

submitterminationEnd_v2() {
 
      this.terminateMemberDetails.proceedWithGreenshield = this.terminationformDetails.get('proceedWithGreenshield').value
      this.terminateMemberDetails.proceedWithRefund = this.terminationformDetails.get('proceedWithRefund').value
      this.terminateMemberDetails.proceedWithSmartchoice = this.terminationformDetails.get('proceedWithSmartchoice').value
      this.terminateMemberDetails.proceedWithSubscriptionExpiry = this.terminationformDetails.get('proceedWithSubscriptionExpiry').value
      this.terminateMemberDetails.proceedWithCancelCustomer = this.terminationformDetails.get('proceedWithCancelCustomer').value
      this.terminateMemberDetails.proceedWithEquitable = this.terminationformDetails.get('proceedWithEquitable').value
      this.terminateMemberDetails.proceedWithPHR = this.terminationformDetails.get('proceedWithPHR').value
      this.terminateMemberDetails.refundAmount = this.terminationformDetails.get('refundAmount').value
 
 
      let data = {
        'data': this.terminateMemberDetails,
        'reason': this.terminationformDetails.get('reason').value ?? " ",
      };
 
      this.logger.log(data);
 
      var corporateId = sessionStorage.getItem('corporateId');
      var accessToken = sessionStorage.getItem('accessToken');
      var terminate = '/api/ap/member/' + this.memberid + '/confirmMemberTermination';
      var headers = {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      };
 
      this.http.post(environment.apiUrl + terminate, data, { headers: headers })
        .subscribe(async (responce: any) => {
          this.logger.log("entering")
          console.log({ responce })
 
          if (responce.status == '200') {
            var details = '/api/ap/admin/customers/list';
 
            // await postServiceWorkerMessage(WorkerMessageType.Delete, [
            //   environment.apiUrl + details
            // ]);
 
            // this.getServiceWorkerDetails()
            $("#DataTables_Table_0").dataTable().fnDestroy();
            Swal.fire({ title: "Info", html: responce.message }).then(async (res) => {
              if (res.isConfirmed) {
 
 
 
                // this.dtTrigger.next(null);
              }
            });
            $('#showTerminateMemberDetails').modal('hide');
            window.location.reload();
 
            // this.globalStoreService.setMemberDetails()
           
 
          } else {
            Swal.fire({ title: "Info", text: responce.message });
          }
 
        }, (error) => {
          Swal.fire({ title: "Error", text: error.message || error.data.message });
        })
    }
 
 
 
 
 
 
  submittermination_v2() {
    if (this.terminationform.invalid) {
      this.terminationform.markAllAsTouched()
      this.toastrService.error(this.lang.Minimium_Date + `:${moment(this.minDate).format('MM-DD-YYYY')} \n` +this.lang.Note +`"${this.note}`);
 
      this.logger.log(this.terminationform.controls)
      return
    }
    this.logger.log(this.terminationform.value)
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var terminate = '/api/ap/member/' + this.memberid + '/configureMemberTermination';
 
    let data = {
      "reason": this.terminationform.value.reason,
      "memberStatus": this.terminationform.value.memberstatus,
      "terminationDate": this.datePipe.transform(
        this.terminationform.value.terminationDate,
        'yyyy-MM-dd'
      ) || ''
    }
    let terminateDate = this.datePipe.transform(this.terminationform.value.terminationDate, 'yyyy-MM-dd') || ''
 
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var terminate = '/api/ap/member/' + this.memberid + '/configureMemberTermination';
    // /member/{memberId}/configureMemberTermination
    let queryParams = new HttpParams();
    queryParams = queryParams.append("terminationDate", terminateDate);
    this.http
      .get(environment.apiUrl + terminate, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
        params: queryParams
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            $("#terminateConfirmDateModal").modal('hide');
            $('#showTerminateMemberDetails').modal('show');
 
            this.terminateMemberDetails = response.data;
 
            // alert(this.terminateMemberDetails.serviceType)
 
            this.logger.log("asasasa", this.terminateMemberDetails);
            this.terminateReasonsApplicable = this?.terminateMemberDetails?.terminateReasonsApplicable || [];
            this.servicDetails = this.terminateMemberDetails.serviceDetails;
            this.terminateReasonsWithKeys = response.data.terminateReasonsWithKeys;
            this.logger.log('terminateReasonsWithKeys', this.terminateReasonsWithKeys);
            this.staxbillDetails = this.terminateMemberDetails.staxbillDetails;
 
            let proceedWithEquitable = this.terminateMemberDetails.proceedWithEquitable;
            let proceedWithGreenshield = this.terminateMemberDetails.proceedWithGreenshield;
            let proceedWithPHR = this.terminateMemberDetails.proceedWithPHR
            let proceedWithRefund = this.terminateMemberDetails.proceedWithRefund;
            let refundAmount = this.staxbillDetails.refundAmount == 'NA' ? "N/A" : this.staxbillDetails.refundAmount;
 
            let proceedWithSmartchoice = this.terminateMemberDetails.proceedWithSmartchoice;
            let proceedWithSubscriptionExpiry = this.terminateMemberDetails.proceedWithSubscriptionExpiry;
            let proceedWithCancelCustomer = this.terminateMemberDetails.proceedWithCancelCustomer;
 
            this.terminationsProvisioning = response.data.terminationsProvisioning
 
            this.terminationformDetails.get('proceedWithEquitable').setValue(proceedWithEquitable);
            this.terminationformDetails.get('proceedWithGreenshield').setValue(proceedWithGreenshield);
            this.terminationformDetails.get('proceedWithPHR').setValue(proceedWithPHR);
            this.terminationformDetails.get('proceedWithRefund').setValue(proceedWithRefund);
            this.terminationformDetails.get('proceedWithSmartchoice').setValue(proceedWithSmartchoice);
            this.terminationformDetails.get('proceedWithSubscriptionExpiry').setValue(proceedWithSubscriptionExpiry);
            this.terminationformDetails.get('proceedWithCancelCustomer').setValue(proceedWithCancelCustomer);
            this.terminationformDetails.get('refundAmount').setValue(refundAmount);
 
 
            for (let control of Object.keys(this.terminationformDetails.controls)) {
              this.terminationformDetails.get(control).updateValueAndValidity();
            }
            // Swal.fire({ title: this.lang.Info, text: response.message })
 
          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
        }, (error) => {
          if (error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: true,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
        }
      );
  }
 
 
 
}
export function moments(date: string | undefined): moment.Moment {

  if (date)

    return moment((new Date(date)).toJSON())

  else

    return moment();

}
